/*window.SHIPPING_CITIES = [
    { "city_name": "אבן יהודה",  "express_enabled": true }, 
    { "city_name": "אביחיל",  "express_enabled": true }, 
    { "city_name": "אודים",  "express_enabled": true }, 
    { "city_name": "אור יהודה",  "express_enabled": true }, 
    { "city_name": "אור עקיבא",  "express_enabled": true }, 
    { "city_name": "אופקים",  "express_enabled": true }, 
    { "city_name": "אורה",  "express_enabled": false }, 
    { "city_name": "אורון",  "express_enabled": false }, 
    { "city_name": "אורות",  "express_enabled": false }, 
    { "city_name": "אורטל",  "express_enabled": false }, 
    { "city_name": "אורים",  "express_enabled": false }, 
    { "city_name": "אורנים",  "express_enabled": false }, 
    { "city_name": "אורנית",  "express_enabled": false }, 
    { "city_name": "אושה",  "express_enabled": false }, 
    { "city_name": "אזור",  "express_enabled": true }, 
    { "city_name": "אחווה",  "express_enabled": false }, 
    { "city_name": "אחוזם",  "express_enabled": false }, 
    { "city_name": "אחוזת ברק",  "express_enabled": false }, 
    { "city_name": "אחיהוד",  "express_enabled": false }, 
    { "city_name": "אחיטוב",  "express_enabled": false }, 
    { "city_name": "אחיסמך",  "express_enabled": true }, 
    { "city_name": "אחיעזר",  "express_enabled": false }, 
    { "city_name": "אטרש (שבט)",  "express_enabled": false }, 
    { "city_name": "איבים",  "express_enabled": false }, 
    { "city_name": "אייל",  "express_enabled": false }, 
    { "city_name": "איילת השחר",  "express_enabled": false }, 
    { "city_name": "אילון",  "express_enabled": false }, 
    { "city_name": "אילון תבור*",  "express_enabled": false }, 
    { "city_name": "אילות",  "express_enabled": false }, 
    { "city_name": "אילנייה",  "express_enabled": false }, 
    { "city_name": "אילת",  "express_enabled": true }, 
    { "city_name": "אירוס",  "express_enabled": false }, 
    { "city_name": "איתמר",  "express_enabled": false }, 
    { "city_name": "איתן",  "express_enabled": false }, 
    { "city_name": "איתנים",  "express_enabled": false }, 
    { "city_name": "אכסאל",  "express_enabled": false }, 
    { "city_name": "אל -עזי",  "express_enabled": false }, 
    { "city_name": "אל -עריאן",  "express_enabled": false }, 
    { "city_name": "אל -רום",  "express_enabled": false }, 
    { "city_name": "אל סייד",  "express_enabled": false }, 
    { "city_name": "אלומה",  "express_enabled": false }, 
    { "city_name": "אלומות",  "express_enabled": false }, 
    { "city_name": "אלון הגליל",  "express_enabled": false }, 
    { "city_name": "אלון מורה",  "express_enabled": false }, 
    { "city_name": "אלון שבות",  "express_enabled": false }, 
    { "city_name": "אלוני אבא",  "express_enabled": false }, 
    { "city_name": "אלוני הבשן",  "express_enabled": false }, 
    { "city_name": "אלוני יצחק",  "express_enabled": false }, 
    { "city_name": "אלונים",  "express_enabled": false }, 
    { "city_name": "אלי-עד",  "express_enabled": false }, 
    { "city_name": "אליאב",  "express_enabled": false }, 
    { "city_name": "אליכין",  "express_enabled": false }, 
    { "city_name": "אליפז",  "express_enabled": false }, 
    { "city_name": "אליפלט",  "express_enabled": false }, 
    { "city_name": "אליקים",  "express_enabled": false }, 
    { "city_name": "אלישיב",  "express_enabled": false }, 
    { "city_name": "אלישמע",  "express_enabled": true }, 
    { "city_name": "אלמגור",  "express_enabled": false }, 
    { "city_name": "אלמוג",  "express_enabled": false }, 
    { "city_name": "אלעד",  "express_enabled": false }, 
    { "city_name": "אלעזר",  "express_enabled": false }, 
    { "city_name": "אלפי מנשה",  "express_enabled": false }, 
    { "city_name": "אלקוש",  "express_enabled": false }, 
    { "city_name": "אלקנה",  "express_enabled": false }, 
    { "city_name": "אמונים",  "express_enabled": true }, 
    { "city_name": "אמירים",  "express_enabled": false }, 
    { "city_name": "אמנון",  "express_enabled": false }, 
    { "city_name": "אמציה",  "express_enabled": false }, 
    { "city_name": "אניעם",  "express_enabled": false }, 
    { "city_name": "אסד (שבט)",  "express_enabled": false }, 
    { "city_name": "אספר",  "express_enabled": false }, 
    { "city_name": "אעבלין",  "express_enabled": false }, 
    { "city_name": "אעצם (שבט)",  "express_enabled": false }, 
    { "city_name": "אפיניש (שבט)",  "express_enabled": false }, 
    { "city_name": "אפיק",  "express_enabled": false }, 
    { "city_name": "אפיקים",  "express_enabled": false }, 
    { "city_name": "אפק",  "express_enabled": false }, 
    { "city_name": "אפרת",  "express_enabled": false }, 
    { "city_name": "ארבל",  "express_enabled": false }, 
    { "city_name": "ארגמן",  "express_enabled": false }, 
    { "city_name": "ארז",  "express_enabled": false }, 
    { "city_name": "אריאל",  "express_enabled": false }, 
    { "city_name": "ארסוף",  "express_enabled": true }, 
    { "city_name": "אשבול",  "express_enabled": false }, 
    { "city_name": "אשבל",  "express_enabled": false }, 
    { "city_name": "אשדוד",  "express_enabled": true }, 
    { "city_name": "אשדות יעקב (איחוד)",  "express_enabled": false }, 
    { "city_name": "אשדות יעקב (מאוחד)",  "express_enabled": false }, 
    { "city_name": "אשחר",  "express_enabled": false }, 
    { "city_name": "אשכולות",  "express_enabled": false }, 
    { "city_name": "אשל הנשיא",  "express_enabled": false }, 
    { "city_name": "אשלים",  "express_enabled": false }, 
    { "city_name": "אשקלון",  "express_enabled": true }, 
    { "city_name": "אשרת",  "express_enabled": false }, 
    { "city_name": "אשתאול",  "express_enabled": false }, 
    { "city_name": "באקה אל-גרביה",  "express_enabled": false }, 
    { "city_name": "באר אורה",  "express_enabled": false }, 
    { "city_name": "באר גנים",  "express_enabled": true }, 
    { "city_name": "באר טוביה",  "express_enabled": false }, 
    { "city_name": "באר יעקב",  "express_enabled": true }, 
    { "city_name": "באר מילכה",  "express_enabled": false }, 
    { "city_name": "באר שבע",  "express_enabled": true }, 
    { "city_name": "בארות יצחק",  "express_enabled": true }, 
    { "city_name": "בארותיים",  "express_enabled": false }, 
    { "city_name": "בארי",  "express_enabled": false }, 
    { "city_name": "בוסתן הגליל",  "express_enabled": false }, 
    { "city_name": "בועיינה-נוג'ידאת",  "express_enabled": false }, 
    { "city_name": "בוקעאתא",  "express_enabled": false }, 
    { "city_name": "בורגתה",  "express_enabled": false }, 
    { "city_name": "בחן",  "express_enabled": false }, 
    { "city_name": "בטחה",  "express_enabled": false }, 
    { "city_name": "ביצרון",  "express_enabled": false }, 
    { "city_name": "ביר אל-מכסור",  "express_enabled": false }, 
    { "city_name": "ביר הדאג'",  "express_enabled": false }, 
    { "city_name": "בירייה",  "express_enabled": false }, 
    { "city_name": "בית אורן",  "express_enabled": false }, 
    { "city_name": "בית אל",  "express_enabled": false }, 
    { "city_name": "בית אלעזרי",  "express_enabled": true }, 
    { "city_name": "בית אלפא",  "express_enabled": false }, 
    { "city_name": "בית אריה-עופרים",  "express_enabled": false }, 
    { "city_name": "בית ברל",  "express_enabled": false }, 
    { "city_name": "בית ג'ן",  "express_enabled": false }, 
    { "city_name": "בית גוברין",  "express_enabled": false }, 
    { "city_name": "בית גמליאל",  "express_enabled": false }, 
    { "city_name": "בית דגן",  "express_enabled": true }, 
    { "city_name": "בית הגדי",  "express_enabled": false }, 
    { "city_name": "בית הלוי",  "express_enabled": false }, 
    { "city_name": "בית הלל",  "express_enabled": false }, 
    { "city_name": "בית העמק",  "express_enabled": false }, 
    { "city_name": "בית הערבה",  "express_enabled": false }, 
    { "city_name": "בית השיטה",  "express_enabled": false }, 
    { "city_name": "בית זיד",  "express_enabled": false }, 
    { "city_name": "בית זית",  "express_enabled": false }, 
    { "city_name": "בית זרע",  "express_enabled": false }, 
    { "city_name": "בית חורון",  "express_enabled": false }, 
    { "city_name": "בית חירות",  "express_enabled": false }, 
    { "city_name": "בית חלקיה",  "express_enabled": false }, 
    { "city_name": "בית חנן",  "express_enabled": true }, 
    { "city_name": "בית חנניה",  "express_enabled": true }, 
    { "city_name": "בית חשמונאי",  "express_enabled": false }, 
    { "city_name": "בית יהושע",  "express_enabled": true }, 
    { "city_name": "בית יוסף",  "express_enabled": false }, 
    { "city_name": "בית ינאי",  "express_enabled": false }, 
    { "city_name": "בית יצחק",  "express_enabled": true }, 
    { "city_name": "בית יצחק-שער חפר",  "express_enabled": true }, 
    { "city_name": "בית לחם הגלילית",  "express_enabled": false }, 
    { "city_name": "בית מאיר",  "express_enabled": false }, 
    { "city_name": "בית נחמיה",  "express_enabled": true }, 
    { "city_name": "בית ניר",  "express_enabled": false }, 
    { "city_name": "בית נקופה",  "express_enabled": false }, 
    { "city_name": "בית עובד",  "express_enabled": true }, 
    { "city_name": "בית עוזיאל",  "express_enabled": false }, 
    { "city_name": "בית עזרא",  "express_enabled": true }, 
    { "city_name": "בית עריף",  "express_enabled": true }, 
    { "city_name": "בית צבי",  "express_enabled": false }, 
    { "city_name": "בית קמה",  "express_enabled": false }, 
    { "city_name": "בית קשת",  "express_enabled": false }, 
    { "city_name": "בית רבן",  "express_enabled": false }, 
    { "city_name": "בית רימון",  "express_enabled": false }, 
    { "city_name": "בית שאן",  "express_enabled": true }, 
    { "city_name": "בית שמש",  "express_enabled": false }, 
    { "city_name": "בית שערים",  "express_enabled": false }, 
    { "city_name": "בית שקמה",  "express_enabled": false }, 
    { "city_name": "ביתן אהרן",  "express_enabled": false }, 
    { "city_name": "ביתר עילית",  "express_enabled": false }, 
    { "city_name": "בלפוריה",  "express_enabled": false }, 
    { "city_name": "בן זכאי",  "express_enabled": true }, 
    { "city_name": "בן עמי",  "express_enabled": false }, 
    { "city_name": "בן שמן (כפר נוער)",  "express_enabled": false }, 
    { "city_name": "בן שמן (מושב)",  "express_enabled": false }, 
    { "city_name": "בני ברק",  "express_enabled": true }, 
    { "city_name": "בני דקלים",  "express_enabled": false }, 
    { "city_name": "בני דרום",  "express_enabled": false }, 
    { "city_name": "בני דרור",  "express_enabled": true }, 
    { "city_name": "בני יהודה",  "express_enabled": false }, 
    { "city_name": "בני נצרים",  "express_enabled": false }, 
    { "city_name": "בני עטרות",  "express_enabled": true }, 
    { "city_name": "בני עי'ש",  "express_enabled": true }, 
    { "city_name": "בני ציון",  "express_enabled": false }, 
    { "city_name": "בני ראם",  "express_enabled": false }, 
    { "city_name": "בניה",  "express_enabled": false }, 
    { "city_name": "בנימינה-גבעת עדה",  "express_enabled": true }, 
    { "city_name": "בסמ'ה",  "express_enabled": false }, 
    { "city_name": "בסמת טבעון",  "express_enabled": false }, 
    { "city_name": "בענה",  "express_enabled": false }, 
    { "city_name": "בצרה",  "express_enabled": true }, 
    { "city_name": "בצת",  "express_enabled": false }, 
    { "city_name": "בקוע",  "express_enabled": false }, 
    { "city_name": "בקעות",  "express_enabled": false }, 
    { "city_name": "בקעת נטופה מ'א 56",  "express_enabled": false }, 
    { "city_name": "בקעת תירען מ'א 3",  "express_enabled": false }, 
    { "city_name": "בר-לב",  "express_enabled": false }, 
    { "city_name": "בר גיורא",  "express_enabled": false }, 
    { "city_name": "בר יוחאי",  "express_enabled": false }, 
    { "city_name": "ברוכין",  "express_enabled": false }, 
    { "city_name": "ברור חיל",  "express_enabled": false }, 
    { "city_name": "ברוש",  "express_enabled": false }, 
    { "city_name": "ברכה",  "express_enabled": false }, 
    { "city_name": "ברכיה",  "express_enabled": false }, 
    { "city_name": "ברעם",  "express_enabled": false }, 
    { "city_name": "ברק",  "express_enabled": false }, 
    { "city_name": "ברקאי",  "express_enabled": false }, 
    { "city_name": "ברקן",  "express_enabled": false }, 
    { "city_name": "ברקת",  "express_enabled": false }, 
    { "city_name": "בת הדר",  "express_enabled": false }, 
    { "city_name": "בת חן",  "express_enabled": false }, 
    { "city_name": "בת חפר",  "express_enabled": false }, 
    { "city_name": "בת ים",  "express_enabled": true }, 
    { "city_name": "בת עין",  "express_enabled": false }, 
    { "city_name": "בת שלמה",  "express_enabled": false }, 
    { "city_name": "בתי זיקוק - קישון",  "express_enabled": false }, 
    { "city_name": "ג'דיידה-מכר",  "express_enabled": false }, 
    { "city_name": "ג'ולס",  "express_enabled": false }, 
    { "city_name": "ג'לג'וליה",  "express_enabled": false }, 
    { "city_name": "ג'נאביב (שבט)",  "express_enabled": false }, 
    { "city_name": "ג'סר א-זרקא",  "express_enabled": false }, 
    { "city_name": "ג'ש (גוש חלב)",  "express_enabled": false }, 
    { "city_name": "ג'ת",  "express_enabled": false }, 
    { "city_name": "גאולי תימן",  "express_enabled": false }, 
    { "city_name": "גאולים",  "express_enabled": true }, 
    { "city_name": "גאון הירדן מ'א 3",  "express_enabled": false }, 
    { "city_name": "גאליה",  "express_enabled": true }, 
    { "city_name": "גבולות",  "express_enabled": false }, 
    { "city_name": "גבים",  "express_enabled": false }, 
    { "city_name": "גבע",  "express_enabled": false }, 
    { "city_name": "גבע בנימין",  "express_enabled": false }, 
    { "city_name": "גבע כרמל",  "express_enabled": false }, 
    { "city_name": "גבעולים",  "express_enabled": false }, 
    { "city_name": "גבעון החדשה",  "express_enabled": false }, 
    { "city_name": "גבעות בר",  "express_enabled": true }, 
    { "city_name": "גבעות עדן",  "express_enabled": false }, 
    { "city_name": "גבעת אבני",  "express_enabled": false }, 
    { "city_name": "גבעת אלה",  "express_enabled": false }, 
    { "city_name": "גבעת ברנר",  "express_enabled": true }, 
    { "city_name": "גבעת השלושה",  "express_enabled": true }, 
    { "city_name": "גבעת זאב",  "express_enabled": false }, 
    { "city_name": "גבעת ח'ן",  "express_enabled": true }, 
    { "city_name": "גבעת חביבה",  "express_enabled": false }, 
    { "city_name": "גבעת חיים (איחוד)",  "express_enabled": false }, 
    { "city_name": "גבעת חיים (מאוחד)",  "express_enabled": false }, 
    { "city_name": "גבעת יואב",  "express_enabled": false }, 
    { "city_name": "גבעת יערים",  "express_enabled": false }, 
    { "city_name": "גבעת ישעיהו",  "express_enabled": false }, 
    { "city_name": "גבעת כ'ח",  "express_enabled": false }, 
    { "city_name": "גבעת ניל'י",  "express_enabled": false }, 
    { "city_name": "גבעת עוז",  "express_enabled": false }, 
    { "city_name": "גבעת שמואל",  "express_enabled": true }, 
    { "city_name": "גבעת שמש",  "express_enabled": false }, 
    { "city_name": "גבעת שפירא",  "express_enabled": false }, 
    { "city_name": "גבעתי",  "express_enabled": false }, 
    { "city_name": "גבעתיים",  "express_enabled": true }, 
    { "city_name": "גברעם",  "express_enabled": false }, 
    { "city_name": "גבת",  "express_enabled": false }, 
    { "city_name": "גדות",  "express_enabled": false }, 
    { "city_name": "גדיש",  "express_enabled": false }, 
    { "city_name": "גדעונה",  "express_enabled": false }, 
    { "city_name": "גדרה",  "express_enabled": true }, 
    { "city_name": "גולן דרומי מ'א 71",  "express_enabled": false }, 
    { "city_name": "גולן צפוני מ'א 71",  "express_enabled": false }, 
    { "city_name": "גולן תיכון מ'א 71",  "express_enabled": false }, 
    { "city_name": "גונן",  "express_enabled": false }, 
    { "city_name": "גורן",  "express_enabled": false }, 
    { "city_name": "גורנות הגליל",  "express_enabled": false }, 
    { "city_name": "גזית",  "express_enabled": false }, 
    { "city_name": "גזר",  "express_enabled": false }, 
    { "city_name": "גיאה",  "express_enabled": false }, 
    { "city_name": "גיבתון",  "express_enabled": true }, 
    { "city_name": "גיזו",  "express_enabled": false }, 
    { "city_name": "גילון",  "express_enabled": false }, 
    { "city_name": "גילת",  "express_enabled": false }, 
    { "city_name": "גינוסר",  "express_enabled": false }, 
    { "city_name": "גיניגר",  "express_enabled": false }, 
    { "city_name": "גינתון",  "express_enabled": false }, 
    { "city_name": "גיתה",  "express_enabled": false }, 
    { "city_name": "גיתית",  "express_enabled": false }, 
    { "city_name": "גלאון",  "express_enabled": false }, 
    { "city_name": "גלגל",  "express_enabled": false }, 
    { "city_name": "גלילות",  "express_enabled": true }, 
    { "city_name": "גליל ים",  "express_enabled": true }, 
    { "city_name": "גליל עליון מז מ'א 1",  "express_enabled": false }, 
    { "city_name": "גליל עליון מז מ'א 2",  "express_enabled": false }, 
    { "city_name": "גליל עליון מז מ'א 55",  "express_enabled": false }, 
    { "city_name": "גליל עליון מז של'ש",  "express_enabled": false }, 
    { "city_name": "גליל תחתון מז מ'א 2",  "express_enabled": false }, 
    { "city_name": "גליל תחתון מז מ'א 3",  "express_enabled": false }, 
    { "city_name": "גליל תחתון מז מ'א 6",  "express_enabled": false }, 
    { "city_name": "גליל תחתון מז של'ש",  "express_enabled": false }, 
    { "city_name": "גלעד (אבן יצחק)",  "express_enabled": false }, 
    { "city_name": "גמ'ל מחוז דרום",  "express_enabled": false }, 
    { "city_name": "גמזו",  "express_enabled": false }, 
    { "city_name": "גן הדרום",  "express_enabled": false }, 
    { "city_name": "גן השומרון",  "express_enabled": false }, 
    { "city_name": "גן חיים",  "express_enabled": true }, 
    { "city_name": "גן יאשיה",  "express_enabled": false }, 
    { "city_name": "גן יבנה",  "express_enabled": true }, 
    { "city_name": "גן נר",  "express_enabled": false }, 
    { "city_name": "גן שורק",  "express_enabled": false }, 
    { "city_name": "גן שלמה",  "express_enabled": false }, 
    { "city_name": "גן שמואל",  "express_enabled": false }, 
    { "city_name": "גנות",  "express_enabled": false }, 
    { "city_name": "גנות הדר",  "express_enabled": true }, 
    { "city_name": "גני הדר",  "express_enabled": false }, 
    { "city_name": "גני טל",  "express_enabled": false }, 
    { "city_name": "גני יוחנן",  "express_enabled": true }, 
    { "city_name": "גני מודיעין",  "express_enabled": false }, 
    { "city_name": "גני עם",  "express_enabled": true }, 
    { "city_name": "גני תקווה",  "express_enabled": true }, 
    { "city_name": "געש",  "express_enabled": true }, 
    { "city_name": "געתון",  "express_enabled": false }, 
    { "city_name": "גפן",  "express_enabled": false }, 
    { "city_name": "גרופית",  "express_enabled": false }, 
    { "city_name": "גשור",  "express_enabled": false }, 
    { "city_name": "גשר",  "express_enabled": false }, 
    { "city_name": "גשר הזיו",  "express_enabled": false }, 
    { "city_name": "גת (קיבוץ)",  "express_enabled": false }, 
    { "city_name": "גת רימון",  "express_enabled": true }, 
    { "city_name": "דאלית אל-כרמל",  "express_enabled": false }, 
    { "city_name": "דבורה",  "express_enabled": false }, 
    { "city_name": "דבורייה",  "express_enabled": false }, 
    { "city_name": "דביר",  "express_enabled": false }, 
    { "city_name": "דברת",  "express_enabled": false }, 
    { "city_name": "דגניה א'",  "express_enabled": false }, 
    { "city_name": "דגניה ב'",  "express_enabled": false }, 
    { "city_name": "דוב'ב",  "express_enabled": false }, 
    { "city_name": "דולב",  "express_enabled": false }, 
    { "city_name": "דור",  "express_enabled": false }, 
    { "city_name": "דורות",  "express_enabled": false }, 
    { "city_name": "דחי",  "express_enabled": false }, 
    { "city_name": "דייר אל-אסד",  "express_enabled": false }, 
    { "city_name": "דייר חנא",  "express_enabled": false }, 
    { "city_name": "דייר ראפאת",  "express_enabled": false }, 
    { "city_name": "דימונה",  "express_enabled": false }, 
    { "city_name": "דישון",  "express_enabled": false }, 
    { "city_name": "דלייה",  "express_enabled": false }, 
    { "city_name": "דלתון",  "express_enabled": false }, 
    { "city_name": "דמיידה",  "express_enabled": false }, 
    { "city_name": "דן",  "express_enabled": false }, 
    { "city_name": "דפנה",  "express_enabled": false }, 
    { "city_name": "דקל",  "express_enabled": false }, 
    { "city_name": "דרום השרון מ'א 18",  "express_enabled": false }, 
    { "city_name": "דרום השרון מ'א 20",  "express_enabled": false }, 
    { "city_name": "דרום השרון של'ש",  "express_enabled": false }, 
    { "city_name": "דרום יהודה",  "express_enabled": false }, 
    { "city_name": "דריג'את",  "express_enabled": false }, 
    { "city_name": "האון",  "express_enabled": false }, 
    { "city_name": "הבונים",  "express_enabled": false }, 
    { "city_name": "הגושרים",  "express_enabled": false }, 
    { "city_name": "הדר עם",  "express_enabled": false }, 
    { "city_name": "הוד השרון",  "express_enabled": true }, 
    { "city_name": "הודיות",  "express_enabled": false }, 
    { "city_name": "הודייה",  "express_enabled": false }, 
    { "city_name": "הוואשלה (שבט)",  "express_enabled": false }, 
    { "city_name": "הוזייל (שבט)",  "express_enabled": false }, 
    { "city_name": "הושעיה",  "express_enabled": false }, 
    { "city_name": "הזורע",  "express_enabled": false }, 
    { "city_name": "הזורעים",  "express_enabled": false }, 
    { "city_name": "החותרים",  "express_enabled": false }, 
    { "city_name": "היוגב",  "express_enabled": false }, 
    { "city_name": "הילה",  "express_enabled": false }, 
    { "city_name": "המעפיל",  "express_enabled": false }, 
    { "city_name": "המרכז למחקר-נחל שורק",  "express_enabled": false }, 
    { "city_name": "הסוללים",  "express_enabled": false }, 
    { "city_name": "העוגן",  "express_enabled": false }, 
    { "city_name": "הערבה מ'א 51",  "express_enabled": false }, 
    { "city_name": "הערבה מ'א 53",  "express_enabled": false }, 
    { "city_name": "הערבה מ'א 54",  "express_enabled": false }, 
    { "city_name": "הר אדר",  "express_enabled": false }, 
    { "city_name": "הר אלכסנדר מ'א 14",  "express_enabled": false }, 
    { "city_name": "הר אלכסנדר מ'א 45",  "express_enabled": false }, 
    { "city_name": "הר אלכסנדר של'ש",  "express_enabled": false }, 
    { "city_name": "הר גילה",  "express_enabled": false }, 
    { "city_name": "הר הנגב הדרומי מ'א 48",  "express_enabled": false }, 
    { "city_name": "הר הנגב הדרומי מ'א 53",  "express_enabled": false }, 
    { "city_name": "הר הנגב הדרומי מ'א 54",  "express_enabled": false }, 
    { "city_name": "הר הנגב הצפוני מ'א 48",  "express_enabled": false }, 
    { "city_name": "הר הנגב הצפוני מ'א 51",  "express_enabled": false }, 
    { "city_name": "הר הנגב הצפוני מ'א 53",  "express_enabled": false }, 
    { "city_name": "הר הנגב הצפוני מ'א 54",  "express_enabled": false }, 
    { "city_name": "הר עמשא",  "express_enabled": false }, 
    { "city_name": "הראל",  "express_enabled": false }, 
    { "city_name": "הרדוף",  "express_enabled": false }, 
    { "city_name": "הרי יהודה מ'א 26",  "express_enabled": false }, 
    { "city_name": "הרי יהודה של'ש",  "express_enabled": false }, 
    { "city_name": "הרי נצרת-תירען",  "express_enabled": false }, 
    { "city_name": "הרי נצרת-תירען מ'א 9",  "express_enabled": false }, 
    { "city_name": "הרצלייה",  "express_enabled": true }, 
    { "city_name": "הררית",  "express_enabled": false }, 
    { "city_name": "השומרון",  "express_enabled": false }, 
    { "city_name": "ורד יריחו",  "express_enabled": false }, 
    { "city_name": "ורדון",  "express_enabled": false }, 
    { "city_name": "זבארגה (שבט)",  "express_enabled": false }, 
    { "city_name": "זבדיאל",  "express_enabled": false }, 
    { "city_name": "זוהר",  "express_enabled": false }, 
    { "city_name": "זיקים",  "express_enabled": false }, 
    { "city_name": "זיתן",  "express_enabled": false }, 
    { "city_name": "זכרון יעקב",  "express_enabled": true }, 
    { "city_name": "זכריה",  "express_enabled": false }, 
    { "city_name": "זמר",  "express_enabled": false }, 
    { "city_name": "זמרת",  "express_enabled": false }, 
    { "city_name": "זנוח",  "express_enabled": false }, 
    { "city_name": "זרועה",  "express_enabled": false }, 
    { "city_name": "זרזיר",  "express_enabled": false }, 
    { "city_name": "זרחיה",  "express_enabled": false }, 
    { "city_name": "ח'ואלד",  "express_enabled": false }, 
    { "city_name": "ח'ואלד (שבט)",  "express_enabled": false }, 
    { "city_name": "חבצלת השרון",  "express_enabled": false }, 
    { "city_name": "חבר",  "express_enabled": false }, 
    { "city_name": "חגור",  "express_enabled": false }, 
    { "city_name": "חגי",  "express_enabled": false }, 
    { "city_name": "חגלה",  "express_enabled": false }, 
    { "city_name": "חד-נס",  "express_enabled": false }, 
    { "city_name": "חדיד",  "express_enabled": false }, 
    { "city_name": "חדרה",  "express_enabled": true }, 
    { "city_name": "חוג'ייראת (ד'הרה) (שבט)",  "express_enabled": false }, 
    { "city_name": "חולדה",  "express_enabled": false }, 
    { "city_name": "חולון",  "express_enabled": true }, 
    { "city_name": "חולית",  "express_enabled": false }, 
    { "city_name": "חולתה",  "express_enabled": false }, 
    { "city_name": "חוסן",  "express_enabled": false }, 
    { "city_name": "חוסנייה",  "express_enabled": false }, 
    { "city_name": "חוף הכרמל מ'א 15",  "express_enabled": false }, 
    { "city_name": "חופית",  "express_enabled": false }, 
    { "city_name": "חוקוק",  "express_enabled": false }, 
    { "city_name": "חורה",  "express_enabled": false }, 
    { "city_name": "חורפיש",  "express_enabled": false }, 
    { "city_name": "חורשים",  "express_enabled": false }, 
    { "city_name": "חזון",  "express_enabled": false }, 
    { "city_name": "חיבת ציון",  "express_enabled": false }, 
    { "city_name": "חיננית",  "express_enabled": false }, 
    { "city_name": "חיפה",  "express_enabled": true }, 
    { "city_name": "חירות",  "express_enabled": false }, 
    { "city_name": "חלוץ",  "express_enabled": false }, 
    { "city_name": "חלץ",  "express_enabled": false }, 
    { "city_name": "חמ'ד",  "express_enabled": true }, 
    { "city_name": "חמאם",  "express_enabled": false }, 
    { "city_name": "חמדיה",  "express_enabled": false }, 
    { "city_name": "חמדת",  "express_enabled": false }, 
    { "city_name": "חמרה",  "express_enabled": false }, 
    { "city_name": "חניאל",  "express_enabled": false }, 
    { "city_name": "חניתה",  "express_enabled": false }, 
    { "city_name": "חנתון",  "express_enabled": false }, 
    { "city_name": "חספין",  "express_enabled": false }, 
    { "city_name": "חפץ חיים",  "express_enabled": false }, 
    { "city_name": "חפצי-בה",  "express_enabled": false }, 
    { "city_name": "חצב",  "express_enabled": false }, 
    { "city_name": "חצבה",  "express_enabled": false }, 
    { "city_name": "חצור-אשדוד",  "express_enabled": false }, 
    { "city_name": "חצור הגלילית",  "express_enabled": false }, 
    { "city_name": "חצרים",  "express_enabled": true }, 
    { "city_name": "חרב לאת",  "express_enabled": false }, 
    { "city_name": "חרות",  "express_enabled": true }, 
    { "city_name": "חרוצים",  "express_enabled": false }, 
    { "city_name": "חריש",  "express_enabled": false }, 
    { "city_name": "חרמון מ'א 71",  "express_enabled": false }, 
    { "city_name": "חרמש",  "express_enabled": false }, 
    { "city_name": "חרשים",  "express_enabled": false }, 
    { "city_name": "חשמונאים",  "express_enabled": false }, 
    { "city_name": "טבריה",  "express_enabled": true }, 
    { "city_name": "טובא-זנגרייה",  "express_enabled": false }, 
    { "city_name": "טורעאן",  "express_enabled": false }, 
    { "city_name": "טייבה",  "express_enabled": false }, 
    { "city_name": "טייבה (בעמק)",  "express_enabled": false }, 
    { "city_name": "טירה",  "express_enabled": false }, 
    { "city_name": "טירת יהודה",  "express_enabled": false }, 
    { "city_name": "טירת כרמל",  "express_enabled": true }, 
    { "city_name": "טירת צבי",  "express_enabled": false }, 
    { "city_name": "טל-אל",  "express_enabled": false }, 
    { "city_name": "טל שחר",  "express_enabled": false }, 
    { "city_name": "טללים",  "express_enabled": false }, 
    { "city_name": "טלמון",  "express_enabled": false }, 
    { "city_name": "טמרה",  "express_enabled": false }, 
    { "city_name": "טמרה (יזרעאל)",  "express_enabled": false }, 
    { "city_name": "טנא",  "express_enabled": false }, 
    { "city_name": "טפחות",  "express_enabled": false }, 
    { "city_name": "יאנוח-ג'ת",  "express_enabled": false }, 
    { "city_name": "יבול",  "express_enabled": false }, 
    { "city_name": "יבנאל",  "express_enabled": false }, 
    { "city_name": "יבנה",  "express_enabled": true }, 
    { "city_name": "יגור",  "express_enabled": true }, 
    { "city_name": "יגל",  "express_enabled": false }, 
    { "city_name": "יד בנימין",  "express_enabled": false }, 
    { "city_name": "יד השמונה",  "express_enabled": false }, 
    { "city_name": "יד חנה",  "express_enabled": false }, 
    { "city_name": "יד מרדכי",  "express_enabled": false }, 
    { "city_name": "יד נתן",  "express_enabled": false }, 
    { "city_name": "יד רמב'ם",  "express_enabled": false }, 
    { "city_name": "ידידה",  "express_enabled": false }, 
    { "city_name": "יהוד-מונוסון",  "express_enabled": true }, 
    { "city_name": "יהל",  "express_enabled": false }, 
    { "city_name": "יובל",  "express_enabled": false }, 
    { "city_name": "יובלים",  "express_enabled": false }, 
    { "city_name": "יודפת",  "express_enabled": false }, 
    { "city_name": "יונתן",  "express_enabled": false }, 
    { "city_name": "יושיביה",  "express_enabled": false }, 
    { "city_name": "יזרעאל",  "express_enabled": false }, 
    { "city_name": "יחיעם",  "express_enabled": false }, 
    { "city_name": "יטבתה",  "express_enabled": false }, 
    { "city_name": "ייט'ב",  "express_enabled": false }, 
    { "city_name": "יכיני",  "express_enabled": false }, 
    { "city_name": "ים המלח - בתי מלון",  "express_enabled": false }, 
    { "city_name": "ינוב",  "express_enabled": true }, 
    { "city_name": "ינון",  "express_enabled": false }, 
    { "city_name": "יסוד המעלה",  "express_enabled": false }, 
    { "city_name": "יסודות",  "express_enabled": false }, 
    { "city_name": "יסעור",  "express_enabled": false }, 
    { "city_name": "יעד",  "express_enabled": false }, 
    { "city_name": "יעל",  "express_enabled": false }, 
    { "city_name": "יעף",  "express_enabled": false }, 
    { "city_name": "יערה",  "express_enabled": false }, 
    { "city_name": "יערות גבעת המורה מ'א 9",  "express_enabled": false }, 
    { "city_name": "יפיע",  "express_enabled": false }, 
    { "city_name": "יפית",  "express_enabled": false }, 
    { "city_name": "יפעת",  "express_enabled": false }, 
    { "city_name": "יפתח",  "express_enabled": false }, 
    { "city_name": "יצהר",  "express_enabled": false }, 
    { "city_name": "יציץ",  "express_enabled": false }, 
    { "city_name": "יקום",  "express_enabled": true }, 
    { "city_name": "יקיר",  "express_enabled": false }, 
    { "city_name": "יקנעם (מושבה)",  "express_enabled": true }, 
    { "city_name": "יקנעם עילית",  "express_enabled": true }, 
    { "city_name": "יראון",  "express_enabled": false }, 
    { "city_name": "ירדנה",  "express_enabled": false }, 
    { "city_name": "ירוחם",  "express_enabled": false }, 
    { "city_name": "ירושלים",  "express_enabled": true }, 
    { "city_name": "ירחיב",  "express_enabled": false }, 
    { "city_name": "ירכא",  "express_enabled": false }, 
    { "city_name": "ירקונה",  "express_enabled": true }, 
    { "city_name": "ישע",  "express_enabled": false }, 
    { "city_name": "ישעי",  "express_enabled": false }, 
    { "city_name": "ישרש",  "express_enabled": false }, 
    { "city_name": "יתד",  "express_enabled": false }, 
    { "city_name": "כאבול",  "express_enabled": false }, 
    { "city_name": "כאוכב אבו אל-היג'א",  "express_enabled": false }, 
    { "city_name": "כברי",  "express_enabled": false }, 
    { "city_name": "כדורי",  "express_enabled": false }, 
    { "city_name": "כדיתה",  "express_enabled": false }, 
    { "city_name": "כוכב השחר",  "express_enabled": false }, 
    { "city_name": "כוכב יאיר",  "express_enabled": false }, 
    { "city_name": "כוכב יעקב",  "express_enabled": false }, 
    { "city_name": "כוכב מיכאל",  "express_enabled": false }, 
    { "city_name": "כורזים",  "express_enabled": false }, 
    { "city_name": "כחל",  "express_enabled": false }, 
    { "city_name": "כחלה",  "express_enabled": false }, 
    { "city_name": "כיסופים",  "express_enabled": false }, 
    { "city_name": "כישור",  "express_enabled": false }, 
    { "city_name": "כליל",  "express_enabled": false }, 
    { "city_name": "כלנית",  "express_enabled": false }, 
    { "city_name": "כמאנה",  "express_enabled": false }, 
    { "city_name": "כמהין",  "express_enabled": false }, 
    { "city_name": "כמון",  "express_enabled": false }, 
    { "city_name": "כנות",  "express_enabled": false }, 
    { "city_name": "כנף",  "express_enabled": false }, 
    { "city_name": "כנרת (מושבה)",  "express_enabled": false }, 
    { "city_name": "כנרת (קבוצה)",  "express_enabled": false }, 
    { "city_name": "כסיפה",  "express_enabled": false }, 
    { "city_name": "כסלון",  "express_enabled": false }, 
    { "city_name": "כסרא-סמיע",  "express_enabled": false }, 
    { "city_name": "כעביה-טבאש-חג'אג'רה",  "express_enabled": false }, 
    { "city_name": "כפר אביב",  "express_enabled": false }, 
    { "city_name": "כפר אדומים",  "express_enabled": false }, 
    { "city_name": "כפר אוריה",  "express_enabled": false }, 
    { "city_name": "כפר אחים",  "express_enabled": false }, 
    { "city_name": "כפר ביאליק",  "express_enabled": false }, 
    { "city_name": "כפר ביל'ו",  "express_enabled": true }, 
    { "city_name": "כפר בלום",  "express_enabled": false }, 
    { "city_name": "כפר בן נון",  "express_enabled": false }, 
    { "city_name": "כפר ברא",  "express_enabled": false }, 
    { "city_name": "כפר ברוך",  "express_enabled": false }, 
    { "city_name": "כפר גדעון",  "express_enabled": false }, 
    { "city_name": "כפר גלים",  "express_enabled": false }, 
    { "city_name": "כפר גליקסון",  "express_enabled": false }, 
    { "city_name": "כפר גלעדי",  "express_enabled": false }, 
    { "city_name": "כפר דניאל",  "express_enabled": false }, 
    { "city_name": "כפר האורנים",  "express_enabled": false }, 
    { "city_name": "כפר החורש",  "express_enabled": false }, 
    { "city_name": "כפר המכבי",  "express_enabled": false }, 
    { "city_name": "כפר הנגיד",  "express_enabled": true }, 
    { "city_name": "כפר הנוער הדתי",  "express_enabled": false }, 
    { "city_name": "כפר הנשיא",  "express_enabled": false }, 
    { "city_name": "כפר הס",  "express_enabled": false }, 
    { "city_name": "כפר הרא'ה",  "express_enabled": false }, 
    { "city_name": "כפר הרי'ף",  "express_enabled": false }, 
    { "city_name": "כפר ויתקין",  "express_enabled": false }, 
    { "city_name": "כפר ורבורג",  "express_enabled": false }, 
    { "city_name": "כפר ורדים",  "express_enabled": false }, 
    { "city_name": "כפר זוהרים",  "express_enabled": false }, 
    { "city_name": "כפר זיתים",  "express_enabled": false }, 
    { "city_name": "כפר חב'ד",  "express_enabled": false }, 
    { "city_name": "כפר חושן",  "express_enabled": false }, 
    { "city_name": "כפר חיטים",  "express_enabled": false }, 
    { "city_name": "כפר חיים",  "express_enabled": false }, 
    { "city_name": "כפר חנניה",  "express_enabled": false }, 
    { "city_name": "כפר חסידים א'",  "express_enabled": false }, 
    { "city_name": "כפר חסידים ב'",  "express_enabled": false }, 
    { "city_name": "כפר חרוב",  "express_enabled": false }, 
    { "city_name": "כפר טרומן",  "express_enabled": true }, 
    { "city_name": "כפר יאסיף",  "express_enabled": false }, 
    { "city_name": "כפר ידידיה",  "express_enabled": false }, 
    { "city_name": "כפר יהושע",  "express_enabled": false }, 
    { "city_name": "כפר יונה",  "express_enabled": true }, 
    { "city_name": "כפר יחזקאל",  "express_enabled": false }, 
    { "city_name": "כפר יעבץ",  "express_enabled": false }, 
    { "city_name": "כפר כמא",  "express_enabled": false }, 
    { "city_name": "כפר כנא",  "express_enabled": false }, 
    { "city_name": "כפר מונש",  "express_enabled": false }, 
    { "city_name": "כפר מימון",  "express_enabled": false }, 
    { "city_name": "כפר מל'ל",  "express_enabled": true }, 
    { "city_name": "כפר מנדא",  "express_enabled": false }, 
    { "city_name": "כפר מנחם",  "express_enabled": false }, 
    { "city_name": "כפר מעש",  "express_enabled": true }, 
    { "city_name": "כפר מסריק",  "express_enabled": false }, 
    { "city_name": "כפר מצר",  "express_enabled": false }, 
    { "city_name": "כפר מרדכי",  "express_enabled": false }, 
    { "city_name": "כפר נטר",  "express_enabled": true }, 
    { "city_name": "כפר סאלד",  "express_enabled": false }, 
    { "city_name": "כפר סבא",  "express_enabled": true }, 
    { "city_name": "כפר סילבר",  "express_enabled": false }, 
    { "city_name": "כפר סירקין",  "express_enabled": true }, 
    { "city_name": "כפר עבודה",  "express_enabled": false }, 
    { "city_name": "כפר עזה",  "express_enabled": false }, 
    { "city_name": "כפר עציון",  "express_enabled": false }, 
    { "city_name": "כפר פינס",  "express_enabled": false }, 
    { "city_name": "כפר קאסם",  "express_enabled": false }, 
    { "city_name": "כפר קיש",  "express_enabled": false }, 
    { "city_name": "כפר קרע",  "express_enabled": false }, 
    { "city_name": "כפר ראש הנקרה",  "express_enabled": false }, 
    { "city_name": "כפר רוזנואלד (זרעית)",  "express_enabled": false }, 
    { "city_name": "כפר רופין",  "express_enabled": false }, 
    { "city_name": "כפר רות",  "express_enabled": false }, 
    { "city_name": "כפר שמאי",  "express_enabled": false }, 
    { "city_name": "כפר שמואל",  "express_enabled": false }, 
    { "city_name": "כפר שמריהו",  "express_enabled": true }, 
    { "city_name": "כפר תבור",  "express_enabled": false }, 
    { "city_name": "כפר תפוח",  "express_enabled": false }, 
    { "city_name": "כרכום",  "express_enabled": false }, 
    { "city_name": "כרם ביבנה (ישיבה)",  "express_enabled": false }, 
    { "city_name": "כרם בן זמרה",  "express_enabled": false }, 
    { "city_name": "כרם בן שמן",  "express_enabled": false }, 
    { "city_name": "כרם מהר'ל",  "express_enabled": false }, 
    { "city_name": "כרם שלום",  "express_enabled": false }, 
    { "city_name": "כרמי יוסף",  "express_enabled": false }, 
    { "city_name": "כרמי צור",  "express_enabled": false }, 
    { "city_name": "כרמי קטיף",  "express_enabled": false }, 
    { "city_name": "כרמיאל",  "express_enabled": true }, 
    { "city_name": "כרמייה",  "express_enabled": false }, 
    { "city_name": "כרמים",  "express_enabled": false }, 
    { "city_name": "כרמל",  "express_enabled": false }, 
    { "city_name": "לבון",  "express_enabled": false }, 
    { "city_name": "לביא",  "express_enabled": false }, 
    { "city_name": "לבנים",  "express_enabled": false }, 
    { "city_name": "להב",  "express_enabled": false }, 
    { "city_name": "להבות הבשן",  "express_enabled": false }, 
    { "city_name": "להבות חביבה",  "express_enabled": false }, 
    { "city_name": "להבים",  "express_enabled": true }, 
    { "city_name": "לוד",  "express_enabled": true }, 
    { "city_name": "לוזית",  "express_enabled": false }, 
    { "city_name": "לוחמי הגיטאות",  "express_enabled": false }, 
    { "city_name": "לוטם",  "express_enabled": false }, 
    { "city_name": "לוטן",  "express_enabled": false }, 
    { "city_name": "לימן",  "express_enabled": false }, 
    { "city_name": "לכיש",  "express_enabled": false }, 
    { "city_name": "לפיד",  "express_enabled": false }, 
    { "city_name": "לפידות",  "express_enabled": false }, 
    { "city_name": "לקיה",  "express_enabled": false }, 
    { "city_name": "מאור",  "express_enabled": false }, 
    { "city_name": "מאיר שפיה",  "express_enabled": false }, 
    { "city_name": "מבוא ביתר",  "express_enabled": false }, 
    { "city_name": "מבוא דותן",  "express_enabled": false }, 
    { "city_name": "מבוא חורון",  "express_enabled": false }, 
    { "city_name": "מבוא חמה",  "express_enabled": false }, 
    { "city_name": "מבוא מודיעים",  "express_enabled": false }, 
    { "city_name": "מבואות ים",  "express_enabled": false }, 
    { "city_name": "מבואות יריחו",  "express_enabled": false }, 
    { "city_name": "מבועים",  "express_enabled": false }, 
    { "city_name": "מבטחים",  "express_enabled": false }, 
    { "city_name": "מבקיעים",  "express_enabled": false }, 
    { "city_name": "מבשרת ציון",  "express_enabled": false }, 
    { "city_name": "מג'ד אל-כרום",  "express_enabled": false }, 
    { "city_name": "מג'דל שמס",  "express_enabled": false }, 
    { "city_name": "מגאר",  "express_enabled": false }, 
    { "city_name": "מגדים",  "express_enabled": false }, 
    { "city_name": "מגדל",  "express_enabled": false }, 
    { "city_name": "מגדל העמק",  "express_enabled": true }, 
    { "city_name": "מגדל עוז",  "express_enabled": false }, 
    { "city_name": "מגדל תפן",  "express_enabled": false }, 
    { "city_name": "מגדלים",  "express_enabled": false }, 
    { "city_name": "מגידו",  "express_enabled": false }, 
    { "city_name": "מגל",  "express_enabled": false }, 
    { "city_name": "מגן",  "express_enabled": false }, 
    { "city_name": "מגן שאול",  "express_enabled": false }, 
    { "city_name": "מגשימים",  "express_enabled": true }, 
    { "city_name": "מדרך עוז",  "express_enabled": false }, 
    { "city_name": "מדרשת בן גוריון",  "express_enabled": false }, 
    { "city_name": "מדרשת רופין",  "express_enabled": false }, 
    { "city_name": "מודיעין-מכבים-רעות",  "express_enabled": true }, 
    { "city_name": "מודיעין עילית",  "express_enabled": false }, 
    { "city_name": "מולדת",  "express_enabled": false }, 
    { "city_name": "מוצא עילית",  "express_enabled": false }, 
    { "city_name": "מוקייבלה",  "express_enabled": false }, 
    { "city_name": "מורן",  "express_enabled": false }, 
    { "city_name": "מורשת",  "express_enabled": false }, 
    { "city_name": "מזור",  "express_enabled": true }, 
    { "city_name": "מזכרת בתיה",  "express_enabled": true }, 
    { "city_name": "מזרע",  "express_enabled": false }, 
    { "city_name": "מזרעה",  "express_enabled": false }, 
    { "city_name": "מחולה",  "express_enabled": false }, 
    { "city_name": "מחנה הילה*",  "express_enabled": false }, 
    { "city_name": "מחנה טלי*",  "express_enabled": false }, 
    { "city_name": "מחנה יהודית*",  "express_enabled": false }, 
    { "city_name": "מחנה יוכבד*",  "express_enabled": false }, 
    { "city_name": "מחנה יפה*",  "express_enabled": false }, 
    { "city_name": "מחנה יתיר",  "express_enabled": false }, 
    { "city_name": "מחנה מרים*",  "express_enabled": false }, 
    { "city_name": "מחנה תל נוף*",  "express_enabled": false }, 
    { "city_name": "מחניים",  "express_enabled": false }, 
    { "city_name": "מחסיה",  "express_enabled": false }, 
    { "city_name": "מטולה",  "express_enabled": false }, 
    { "city_name": "מטע",  "express_enabled": false }, 
    { "city_name": "מי עמי",  "express_enabled": false }, 
    { "city_name": "מיטב",  "express_enabled": false }, 
    { "city_name": "מיטל",  "express_enabled": false }, 
    { "city_name": "מייסר",  "express_enabled": false }, 
    { "city_name": "מיצר",  "express_enabled": false }, 
    { "city_name": "מירב",  "express_enabled": false }, 
    { "city_name": "מירון",  "express_enabled": false }, 
    { "city_name": "מישר",  "express_enabled": false }, 
    { "city_name": "מיתר",  "express_enabled": true }, 
    { "city_name": "מכורה",  "express_enabled": false }, 
    { "city_name": "מכחול",  "express_enabled": false }, 
    { "city_name": "מכמורת",  "express_enabled": false }, 
    { "city_name": "מכמנים",  "express_enabled": false }, 
    { "city_name": "מלאה",  "express_enabled": false }, 
    { "city_name": "מלילות",  "express_enabled": false }, 
    { "city_name": "מלכייה",  "express_enabled": false }, 
    { "city_name": "מנוחה",  "express_enabled": false }, 
    { "city_name": "מנוף",  "express_enabled": false }, 
    { "city_name": "מנות",  "express_enabled": false }, 
    { "city_name": "מנחמיה",  "express_enabled": false }, 
    { "city_name": "מנרה",  "express_enabled": false }, 
    { "city_name": "מנשית זבדה",  "express_enabled": false }, 
    { "city_name": "מסד",  "express_enabled": false }, 
    { "city_name": "מסדה",  "express_enabled": false }, 
    { "city_name": "מסילות",  "express_enabled": false }, 
    { "city_name": "מסילת ציון",  "express_enabled": false }, 
    { "city_name": "מסלול",  "express_enabled": false }, 
    { "city_name": "מסעדה",  "express_enabled": false }, 
    { "city_name": "מסעודין אל-עזאזמה (שבט)",  "express_enabled": false }, 
    { "city_name": "מעברות",  "express_enabled": false }, 
    { "city_name": "מעגלים",  "express_enabled": false }, 
    { "city_name": "מעגן",  "express_enabled": false }, 
    { "city_name": "מעגן מיכאל",  "express_enabled": true }, 
    { "city_name": "מעוז חיים",  "express_enabled": false }, 
    { "city_name": "מעון",  "express_enabled": false }, 
    { "city_name": "מעונה",  "express_enabled": false }, 
    { "city_name": "מעיין ברוך",  "express_enabled": false }, 
    { "city_name": "מעיין צבי",  "express_enabled": false }, 
    { "city_name": "מעיליא",  "express_enabled": false }, 
    { "city_name": "מעלה אדומים",  "express_enabled": false }, 
    { "city_name": "מעלה אפרים",  "express_enabled": false }, 
    { "city_name": "מעלה גלבוע",  "express_enabled": false }, 
    { "city_name": "מעלה גמלא",  "express_enabled": false }, 
    { "city_name": "מעלה החמישה",  "express_enabled": false }, 
    { "city_name": "מעלה לבונה",  "express_enabled": false }, 
    { "city_name": "מעלה מכמש",  "express_enabled": false }, 
    { "city_name": "מעלה עירון",  "express_enabled": false }, 
    { "city_name": "מעלה עמוס",  "express_enabled": false }, 
    { "city_name": "מעלות-תרשיחא",  "express_enabled": false }, 
    { "city_name": "מענית",  "express_enabled": false }, 
    { "city_name": "מערב השרון מ'א 16",  "express_enabled": false }, 
    { "city_name": "מערב השרון מ'א 18",  "express_enabled": false }, 
    { "city_name": "מערב השרון מ'א 19",  "express_enabled": false }, 
    { "city_name": "מעש",  "express_enabled": false }, 
    { "city_name": "מפלסים",  "express_enabled": false }, 
    { "city_name": "מפעלי ברקן",  "express_enabled": false }, 
    { "city_name": "מפעלי גליל עליון",  "express_enabled": false }, 
    { "city_name": "מפעלי גרנות",  "express_enabled": false }, 
    { "city_name": "מפעלי העמק (יזרעאל)",  "express_enabled": false }, 
    { "city_name": "מפעלי חבל מודיעים",  "express_enabled": false }, 
    { "city_name": "מפעלי ים המלח(סדום)",  "express_enabled": false }, 
    { "city_name": "מפעלי כנות",  "express_enabled": false }, 
    { "city_name": "מפעלי מישור רותם",  "express_enabled": false }, 
    { "city_name": "מפעלי מעון",  "express_enabled": false }, 
    { "city_name": "מפעלי צומת מלאכי",  "express_enabled": false }, 
    { "city_name": "מפעלי צין - ערבה",  "express_enabled": false }, 
    { "city_name": "מפעלי צמח",  "express_enabled": false }, 
    { "city_name": "מפעלי שאן",  "express_enabled": false }, 
    { "city_name": "מצדות יהודה",  "express_enabled": false }, 
    { "city_name": "מצובה",  "express_enabled": false }, 
    { "city_name": "מצליח",  "express_enabled": false }, 
    { "city_name": "מצפה",  "express_enabled": false }, 
    { "city_name": "מצפה אבי'ב",  "express_enabled": false }, 
    { "city_name": "מצפה אילן",  "express_enabled": false }, 
    { "city_name": "מצפה יריחו",  "express_enabled": false }, 
    { "city_name": "מצפה נטופה",  "express_enabled": false }, 
    { "city_name": "מצפה רמון",  "express_enabled": false }, 
    { "city_name": "מצפה שלם",  "express_enabled": false }, 
    { "city_name": "מצר",  "express_enabled": false }, 
    { "city_name": "מקווה ישראל",  "express_enabled": true }, 
    { "city_name": "מרגליות",  "express_enabled": false }, 
    { "city_name": "מרום גולן",  "express_enabled": false }, 
    { "city_name": "מרחב עם",  "express_enabled": false }, 
    { "city_name": "מרחביה (מושב)",  "express_enabled": false }, 
    { "city_name": "מרחביה (קיבוץ)",  "express_enabled": false }, 
    { "city_name": "מרכז אזורי כדורי",  "express_enabled": false }, 
    { "city_name": "מרכז אזורי מרום הגליל",  "express_enabled": false }, 
    { "city_name": "מרכז אזורי משגב",  "express_enabled": false }, 
    { "city_name": "מרכז אזורי שוהם",  "express_enabled": false }, 
    { "city_name": "מרכז כ'ח",  "express_enabled": false }, 
    { "city_name": "מרכז מיר'ב*",  "express_enabled": false }, 
    { "city_name": "מרכז שפירא",  "express_enabled": false }, 
    { "city_name": "משאבי שדה",  "express_enabled": false }, 
    { "city_name": "משגב דב",  "express_enabled": false }, 
    { "city_name": "משגב עם",  "express_enabled": false }, 
    { "city_name": "משהד",  "express_enabled": false }, 
    { "city_name": "משואה",  "express_enabled": false }, 
    { "city_name": "משואות יצחק",  "express_enabled": false }, 
    { "city_name": "משכיות",  "express_enabled": false }, 
    { "city_name": "משמר איילון",  "express_enabled": false }, 
    { "city_name": "משמר דוד",  "express_enabled": false }, 
    { "city_name": "משמר הירדן",  "express_enabled": false }, 
    { "city_name": "משמר הנגב",  "express_enabled": false }, 
    { "city_name": "משמר העמק",  "express_enabled": false }, 
    { "city_name": "משמר השבעה",  "express_enabled": true }, 
    { "city_name": "משמר השרון",  "express_enabled": false }, 
    { "city_name": "משמרות",  "express_enabled": false }, 
    { "city_name": "משמרת",  "express_enabled": false }, 
    { "city_name": "משען",  "express_enabled": false }, 
    { "city_name": "מתן",  "express_enabled": false }, 
    { "city_name": "מתת",  "express_enabled": false }, 
    { "city_name": "מתתיהו",  "express_enabled": false }, 
    { "city_name": "נאות גולן",  "express_enabled": false }, 
    { "city_name": "נאות הכיכר",  "express_enabled": false }, 
    { "city_name": "נאות חובב",  "express_enabled": false }, 
    { "city_name": "נאות מרדכי",  "express_enabled": false }, 
    { "city_name": "נאות סמדר",  "express_enabled": false }, 
    { "city_name": "נאעורה",  "express_enabled": false }, 
    { "city_name": "נבטים",  "express_enabled": false }, 
    { "city_name": "נגבה",  "express_enabled": false }, 
    { "city_name": "נגוהות",  "express_enabled": false }, 
    { "city_name": "נהורה",  "express_enabled": false }, 
    { "city_name": "נהלל",  "express_enabled": false }, 
    { "city_name": "נהרייה",  "express_enabled": true }, 
    { "city_name": "נוב",  "express_enabled": false }, 
    { "city_name": "נוגה",  "express_enabled": false }, 
    { "city_name": "נווה",  "express_enabled": false }, 
    { "city_name": "נווה אבות",  "express_enabled": false }, 
    { "city_name": "נווה אור",  "express_enabled": false }, 
    { "city_name": "נווה אטי'ב",  "express_enabled": false }, 
    { "city_name": "נווה אילן",  "express_enabled": false }, 
    { "city_name": "נווה אילן",  "express_enabled": false }, 
    { "city_name": "נווה איתן",  "express_enabled": false }, 
    { "city_name": "נווה דניאל",  "express_enabled": false }, 
    { "city_name": "נווה זוהר",  "express_enabled": false }, 
    { "city_name": "נווה זיו",  "express_enabled": false }, 
    { "city_name": "נווה חריף",  "express_enabled": false }, 
    { "city_name": "נווה ים",  "express_enabled": false }, 
    { "city_name": "נווה ימין",  "express_enabled": true }, 
    { "city_name": "נווה ירק",  "express_enabled": true }, 
    { "city_name": "נווה מבטח",  "express_enabled": false }, 
    { "city_name": "נווה מיכאל",  "express_enabled": false }, 
    { "city_name": "נווה צוף",  "express_enabled": false }, 
    { "city_name": "נווה שלום",  "express_enabled": false }, 
    { "city_name": "נועם",  "express_enabled": false }, 
    { "city_name": "נוף איילון",  "express_enabled": false }, 
    { "city_name": "נוף הגליל",  "express_enabled": false }, 
    { "city_name": "נופים",  "express_enabled": false }, 
    { "city_name": "נופית",  "express_enabled": false }, 
    { "city_name": "נופך",  "express_enabled": true }, 
    { "city_name": "נוקדים",  "express_enabled": false }, 
    { "city_name": "נורדייה",  "express_enabled": true }, 
    { "city_name": "נורית",  "express_enabled": false }, 
    { "city_name": "נחושה",  "express_enabled": false }, 
    { "city_name": "נחל יפתחאל מ'א 3",  "express_enabled": false }, 
    { "city_name": "נחל עוז",  "express_enabled": false }, 
    { "city_name": "נחל תבור מ'א 8",  "express_enabled": false }, 
    { "city_name": "נחלה",  "express_enabled": false }, 
    { "city_name": "נחליאל",  "express_enabled": false }, 
    { "city_name": "נחלים",  "express_enabled": true }, 
    { "city_name": "נחם",  "express_enabled": false }, 
    { "city_name": "נחף",  "express_enabled": false }, 
    { "city_name": "נחשולים",  "express_enabled": false }, 
    { "city_name": "נחשון",  "express_enabled": false }, 
    { "city_name": "נחשונים",  "express_enabled": false }, 
    { "city_name": "נטועה",  "express_enabled": false }, 
    { "city_name": "נטור",  "express_enabled": false }, 
    { "city_name": "נטע",  "express_enabled": false }, 
    { "city_name": "נטעים",  "express_enabled": true }, 
    { "city_name": "נטף",  "express_enabled": false }, 
    { "city_name": "ניין",  "express_enabled": false }, 
    { "city_name": "ניל'י",  "express_enabled": false }, 
    { "city_name": "ניצן",  "express_enabled": false }, 
    { "city_name": "ניצן ב'",  "express_enabled": false }, 
    { "city_name": "ניצנה (קהילת חינוך)",  "express_enabled": false }, 
    { "city_name": "ניצני סיני",  "express_enabled": false }, 
    { "city_name": "ניצני עוז",  "express_enabled": false }, 
    { "city_name": "ניצנים",  "express_enabled": true }, 
    { "city_name": "ניר אליהו",  "express_enabled": false }, 
    { "city_name": "ניר בנים",  "express_enabled": false }, 
    { "city_name": "ניר גלים",  "express_enabled": false }, 
    { "city_name": "ניר דוד (תל עמל)",  "express_enabled": false }, 
    { "city_name": "ניר ח'ן",  "express_enabled": false }, 
    { "city_name": "ניר יפה",  "express_enabled": false }, 
    { "city_name": "ניר יצחק",  "express_enabled": false }, 
    { "city_name": "ניר ישראל",  "express_enabled": false }, 
    { "city_name": "ניר משה",  "express_enabled": false }, 
    { "city_name": "ניר עוז",  "express_enabled": false }, 
    { "city_name": "ניר עם",  "express_enabled": false }, 
    { "city_name": "ניר עציון",  "express_enabled": false }, 
    { "city_name": "ניר עקיבא",  "express_enabled": false }, 
    { "city_name": "ניר צבי",  "express_enabled": true }, 
    { "city_name": "נירים",  "express_enabled": false }, 
    { "city_name": "נירית",  "express_enabled": false }, 
    { "city_name": "נמל תעופה בן-גוריון",  "express_enabled": false }, 
    { "city_name": "נמרוד",  "express_enabled": false }, 
    { "city_name": "נס הרים",  "express_enabled": false }, 
    { "city_name": "נס עמים",  "express_enabled": false }, 
    { "city_name": "נס ציונה",  "express_enabled": true }, 
    { "city_name": "נעורים",  "express_enabled": false }, 
    { "city_name": "נעלה",  "express_enabled": false }, 
    { "city_name": "נעמ'ה",  "express_enabled": false }, 
    { "city_name": "נען",  "express_enabled": false }, 
    { "city_name": "נערן",  "express_enabled": false }, 
    { "city_name": "נפת בית לחם",  "express_enabled": false }, 
    { "city_name": "נפת בית לחם מ'א 76",  "express_enabled": false }, 
    { "city_name": "נפת ג'נין",  "express_enabled": false }, 
    { "city_name": "נפת ג'נין מ'א 72",  "express_enabled": false }, 
    { "city_name": "נפת חברון",  "express_enabled": false }, 
    { "city_name": "נפת חברון מ'א 78",  "express_enabled": false }, 
    { "city_name": "נפת טול כרם",  "express_enabled": false }, 
    { "city_name": "נפת ירדן",  "express_enabled": false }, 
    { "city_name": "נפת ירדן מ'א 74",  "express_enabled": false }, 
    { "city_name": "נפת ירדן מ'א 75",  "express_enabled": false }, 
    { "city_name": "נפת ראמאללה",  "express_enabled": false }, 
    { "city_name": "נפת ראמאללה מ'א 73",  "express_enabled": false }, 
    { "city_name": "נפת ראמאללה מ'א 73",  "express_enabled": false }, 
    { "city_name": "נפת שכם",  "express_enabled": false }, 
    { "city_name": "נפת שכם מ'א 72",  "express_enabled": false }, 
    { "city_name": "נצאצרה (שבט)",  "express_enabled": false }, 
    { "city_name": "נצר חזני",  "express_enabled": false }, 
    { "city_name": "נצר סרני",  "express_enabled": false }, 
    { "city_name": "נצרת",  "express_enabled": false }, 
    { "city_name": "נשר",  "express_enabled": true }, 
    { "city_name": "נתיב הגדוד",  "express_enabled": false }, 
    { "city_name": "נתיב הל'ה",  "express_enabled": false }, 
    { "city_name": "נתיב העשרה",  "express_enabled": false }, 
    { "city_name": "נתיב השיירה",  "express_enabled": false }, 
    { "city_name": "נתיבות",  "express_enabled": true }, 
    { "city_name": "נתניה",  "express_enabled": true }, 
    { "city_name": "סאג'ור",  "express_enabled": false }, 
    { "city_name": "סאסא",  "express_enabled": false }, 
    { "city_name": "סביון",  "express_enabled": true }, 
    { "city_name": "סגולה",  "express_enabled": false }, 
    { "city_name": "סואעד (חמרייה)*",  "express_enabled": false }, 
    { "city_name": "סואעד (כמאנה) (שבט)",  "express_enabled": false }, 
    { "city_name": "סולם",  "express_enabled": false }, 
    { "city_name": "סוסיה",  "express_enabled": false }, 
    { "city_name": "סופה",  "express_enabled": false }, 
    { "city_name": "סח'נין",  "express_enabled": false }, 
    { "city_name": "סייד (שבט)",  "express_enabled": false }, 
    { "city_name": "סלמה",  "express_enabled": false }, 
    { "city_name": "סלעית",  "express_enabled": false }, 
    { "city_name": "סמר",  "express_enabled": false }, 
    { "city_name": "סנסנה",  "express_enabled": false }, 
    { "city_name": "סעד",  "express_enabled": false }, 
    { "city_name": "סעוה",  "express_enabled": false }, 
    { "city_name": "סער",  "express_enabled": false }, 
    { "city_name": "ספיר",  "express_enabled": false }, 
    { "city_name": "סתרייה",  "express_enabled": false }, 
    { "city_name": "ע'ג'ר",  "express_enabled": false }, 
    { "city_name": "עבדון",  "express_enabled": false }, 
    { "city_name": "עברון",  "express_enabled": false }, 
    { "city_name": "עגור",  "express_enabled": false }, 
    { "city_name": "עד הלום",  "express_enabled": false }, 
    { "city_name": "עדי",  "express_enabled": false }, 
    { "city_name": "עדנים",  "express_enabled": true }, 
    { "city_name": "עוזה",  "express_enabled": false }, 
    { "city_name": "עוזייר",  "express_enabled": false }, 
    { "city_name": "עולש",  "express_enabled": false }, 
    { "city_name": "עומר",  "express_enabled": true }, 
    { "city_name": "עופר",  "express_enabled": false }, 
    { "city_name": "עוצם",  "express_enabled": false }, 
    { "city_name": "עוקבי (בנו עוקבה) (שבט)",  "express_enabled": false }, 
    { "city_name": "עזוז",  "express_enabled": false }, 
    { "city_name": "עזר",  "express_enabled": false }, 
    { "city_name": "עזריאל",  "express_enabled": false }, 
    { "city_name": "עזריה",  "express_enabled": false }, 
    { "city_name": "עזריקם",  "express_enabled": false }, 
    { "city_name": "עטאוונה (שבט)",  "express_enabled": false }, 
    { "city_name": "עטרת",  "express_enabled": false }, 
    { "city_name": "עידן",  "express_enabled": false }, 
    { "city_name": "עידן הנגב",  "express_enabled": false }, 
    { "city_name": "עיילבון",  "express_enabled": false }, 
    { "city_name": "עיינות",  "express_enabled": false }, 
    { "city_name": "עילוט",  "express_enabled": false }, 
    { "city_name": "עין איילה",  "express_enabled": false }, 
    { "city_name": "עין אל-אסד",  "express_enabled": false }, 
    { "city_name": "עין גב",  "express_enabled": false }, 
    { "city_name": "עין גדי",  "express_enabled": false }, 
    { "city_name": "עין דור",  "express_enabled": false }, 
    { "city_name": "עין הבשור",  "express_enabled": false }, 
    { "city_name": "עין הוד",  "express_enabled": false }, 
    { "city_name": "עין החורש",  "express_enabled": false }, 
    { "city_name": "עין המפרץ",  "express_enabled": false }, 
    { "city_name": "עין הנצי'ב",  "express_enabled": false }, 
    { "city_name": "עין העמק",  "express_enabled": false }, 
    { "city_name": "עין השופט",  "express_enabled": false }, 
    { "city_name": "עין השלושה",  "express_enabled": false }, 
    { "city_name": "עין ורד",  "express_enabled": true }, 
    { "city_name": "עין זיוון",  "express_enabled": false }, 
    { "city_name": "עין חוד",  "express_enabled": false }, 
    { "city_name": "עין חצבה",  "express_enabled": false }, 
    { "city_name": "עין חרוד (איחוד)",  "express_enabled": false }, 
    { "city_name": "עין חרוד (מאוחד)",  "express_enabled": false }, 
    { "city_name": "עין יהב",  "express_enabled": false }, 
    { "city_name": "עין יעקב",  "express_enabled": false }, 
    { "city_name": "עין כרם-בי'ס חקלאי",  "express_enabled": false }, 
    { "city_name": "עין כרמל",  "express_enabled": false }, 
    { "city_name": "עין מאהל",  "express_enabled": false }, 
    { "city_name": "עין נקובא",  "express_enabled": false }, 
    { "city_name": "עין עירון",  "express_enabled": false }, 
    { "city_name": "עין צורים",  "express_enabled": false }, 
    { "city_name": "עין קנייא",  "express_enabled": false }, 
    { "city_name": "עין ראפה",  "express_enabled": false }, 
    { "city_name": "עין שמר",  "express_enabled": false }, 
    { "city_name": "עין שריד",  "express_enabled": true }, 
    { "city_name": "עין תמר",  "express_enabled": false }, 
    { "city_name": "עינת",  "express_enabled": true }, 
    { "city_name": "עינות",  "express_enabled": true }, 
    { "city_name": "עיר אובות",  "express_enabled": false }, 
    { "city_name": "עכו",  "express_enabled": true }, 
    { "city_name": "עלומים",  "express_enabled": false }, 
    { "city_name": "עלי",  "express_enabled": false }, 
    { "city_name": "עלי זהב",  "express_enabled": false }, 
    { "city_name": "עלמה",  "express_enabled": false }, 
    { "city_name": "עלמון",  "express_enabled": false }, 
    { "city_name": "עמוקה",  "express_enabled": false }, 
    { "city_name": "עמיחי",  "express_enabled": false }, 
    { "city_name": "עמינדב",  "express_enabled": false }, 
    { "city_name": "עמיעד",  "express_enabled": false }, 
    { "city_name": "עמיעוז",  "express_enabled": false }, 
    { "city_name": "עמיקם",  "express_enabled": false }, 
    { "city_name": "עמיר",  "express_enabled": false }, 
    { "city_name": "עמנואל",  "express_enabled": false }, 
    { "city_name": "עמק בית שאן מ'א 7",  "express_enabled": false }, 
    { "city_name": "עמק בית שאן של'ש",  "express_enabled": false }, 
    { "city_name": "עמק חולה מ'א 1",  "express_enabled": false }, 
    { "city_name": "עמק חולה מ'א 55",  "express_enabled": false }, 
    { "city_name": "עמק חולה של'ש",  "express_enabled": false }, 
    { "city_name": "עמק חפר מזרח מ'א 16",  "express_enabled": false }, 
    { "city_name": "עמק חרוד מ'א 8",  "express_enabled": false }, 
    { "city_name": "עמק חרוד של'ש",  "express_enabled": false }, 
    { "city_name": "עמק יזרעאל מ'א 13",  "express_enabled": false }, 
    { "city_name": "עמק יזרעאל מ'א 8",  "express_enabled": false }, 
    { "city_name": "עמק יזרעאל מ'א 9",  "express_enabled": false }, 
    { "city_name": "עמקה",  "express_enabled": false }, 
    { "city_name": "ענב",  "express_enabled": false }, 
    { "city_name": "עספיא",  "express_enabled": false }, 
    { "city_name": "עפולה",  "express_enabled": true }, 
    { "city_name": "עפרה",  "express_enabled": false }, 
    { "city_name": "עצמון שגב",  "express_enabled": false }, 
    { "city_name": "עראבה",  "express_enabled": false }, 
    { "city_name": "עראמשה",  "express_enabled": false }, 
    { "city_name": "ערב אל נעים",  "express_enabled": false }, 
    { "city_name": "ערד",  "express_enabled": false }, 
    { "city_name": "ערוגות",  "express_enabled": false }, 
    { "city_name": "ערערה",  "express_enabled": false }, 
    { "city_name": "ערערה-בנגב",  "express_enabled": false }, 
    { "city_name": "עשרת",  "express_enabled": false }, 
    { "city_name": "עתלית",  "express_enabled": false }, 
    { "city_name": "עתניאל",  "express_enabled": false }, 
    { "city_name": "פארן",  "express_enabled": false }, 
    { "city_name": "פארק הירדן מ'א 6",  "express_enabled": false }, 
    { "city_name": "פארק תעשיות ספירים",  "express_enabled": false }, 
    { "city_name": "פארק תעשיות עמק חפר",  "express_enabled": false }, 
    { "city_name": "פדואל",  "express_enabled": false }, 
    { "city_name": "פדויים",  "express_enabled": false }, 
    { "city_name": "פדיה",  "express_enabled": false }, 
    { "city_name": "פוריידיס",  "express_enabled": false }, 
    { "city_name": "פורייה - כפר עבודה",  "express_enabled": false }, 
    { "city_name": "פורייה - נווה עובד",  "express_enabled": false }, 
    { "city_name": "פורייה עילית",  "express_enabled": false }, 
    { "city_name": "פורת",  "express_enabled": false }, 
    { "city_name": "פטיש",  "express_enabled": false }, 
    { "city_name": "פלך",  "express_enabled": false }, 
    { "city_name": "פלמחים",  "express_enabled": false }, 
    { "city_name": "פני חבר",  "express_enabled": false }, 
    { "city_name": "פסגות",  "express_enabled": false }, 
    { "city_name": "פסוטה",  "express_enabled": false }, 
    { "city_name": "פעמי תש'ז",  "express_enabled": false }, 
    { "city_name": "פצאל",  "express_enabled": false }, 
    { "city_name": "פקיעין (בוקייעה)",  "express_enabled": false }, 
    { "city_name": "פקיעין חדשה",  "express_enabled": false }, 
    { "city_name": "פרדס חנה-כרכור",  "express_enabled": true }, 
    { "city_name": "פרדסייה",  "express_enabled": true }, 
    { "city_name": "פרוד",  "express_enabled": false }, 
    { "city_name": "פרזון",  "express_enabled": false }, 
    { "city_name": "פרי גן",  "express_enabled": false }, 
    { "city_name": "פתח תקווה",  "express_enabled": true }, 
    { "city_name": "פתחיה",  "express_enabled": false }, 
    { "city_name": "צאלים",  "express_enabled": false }, 
    { "city_name": "צביה",  "express_enabled": false }, 
    { "city_name": "צבעון",  "express_enabled": false }, 
    { "city_name": "צובה",  "express_enabled": false }, 
    { "city_name": "צוחר",  "express_enabled": false }, 
    { "city_name": "צופייה",  "express_enabled": false }, 
    { "city_name": "צופים",  "express_enabled": false }, 
    { "city_name": "צופית",  "express_enabled": true }, 
    { "city_name": "צופר",  "express_enabled": false }, 
    { "city_name": "צוקי ים",  "express_enabled": false }, 
    { "city_name": "צוקים",  "express_enabled": false }, 
    { "city_name": "צור הדסה",  "express_enabled": false }, 
    { "city_name": "צור יצחק",  "express_enabled": false }, 
    { "city_name": "צור משה",  "express_enabled": true }, 
    { "city_name": "צור נתן",  "express_enabled": false }, 
    { "city_name": "צוריאל",  "express_enabled": false }, 
    { "city_name": "צורית",  "express_enabled": false }, 
    { "city_name": "ציפורי",  "express_enabled": false }, 
    { "city_name": "צלפון",  "express_enabled": false }, 
    { "city_name": "צנדלה",  "express_enabled": false }, 
    { "city_name": "צפרייה",  "express_enabled": false }, 
    { "city_name": "צפרירים",  "express_enabled": false }, 
    { "city_name": "צפת",  "express_enabled": false }, 
    { "city_name": "צרופה",  "express_enabled": false }, 
    { "city_name": "צרעה",  "express_enabled": false }, 
    { "city_name": "קבועה (שבט)",  "express_enabled": false }, 
    { "city_name": "קבוצת יבנה",  "express_enabled": false }, 
    { "city_name": "קדומים",  "express_enabled": true }, 
    { "city_name": "קדימה-צורן",  "express_enabled": true }, 
    { "city_name": "קדמה",  "express_enabled": false }, 
    { "city_name": "קדמת צבי",  "express_enabled": false }, 
    { "city_name": "קדר",  "express_enabled": false }, 
    { "city_name": "קדרון",  "express_enabled": true }, 
    { "city_name": "קדרים",  "express_enabled": false }, 
    { "city_name": "קודייראת א-צאנע (שבט)",  "express_enabled": false }, 
    { "city_name": "קוואעין (שבט)",  "express_enabled": false }, 
    { "city_name": "קוממיות",  "express_enabled": false }, 
    { "city_name": "קורנית",  "express_enabled": false }, 
    { "city_name": "קטורה",  "express_enabled": false }, 
    { "city_name": "קיסריה",  "express_enabled": true }, 
    { "city_name": "קלחים",  "express_enabled": false }, 
    { "city_name": "קליה",  "express_enabled": false }, 
    { "city_name": "קלנסווה",  "express_enabled": false }, 
    { "city_name": "קלע",  "express_enabled": false }, 
    { "city_name": "קמה (אזור תעשייה חקלאית)",  "express_enabled": false }, 
    { "city_name": "קציר",  "express_enabled": false }, 
    { "city_name": "קצר א-סר",  "express_enabled": false }, 
    { "city_name": "קצרין",  "express_enabled": false }, 
    { "city_name": "קריית אונו",  "express_enabled": true }, 
    { "city_name": "קריית ארבע",  "express_enabled": false }, 
    { "city_name": "קריית אתא",  "express_enabled": true }, 
    { "city_name": "קריית ביאליק",  "express_enabled": true }, 
    { "city_name": "קריית גת",  "express_enabled": true }, 
    { "city_name": "קריית חינוך מרחבים*",  "express_enabled": false }, 
    { "city_name": "קריית טבעון",  "express_enabled": true }, 
    { "city_name": "קריית ים",  "express_enabled": true }, 
    { "city_name": "קריית יערים",  "express_enabled": false }, 
    { "city_name": "קריית יערים (מוסד)",  "express_enabled": false }, 
    { "city_name": "קריית מוצקין",  "express_enabled": true }, 
    { "city_name": "קריית מלאכי",  "express_enabled": false }, 
    { "city_name": "קריית נטפים",  "express_enabled": false }, 
    { "city_name": "קריית ענבים",  "express_enabled": false }, 
    { "city_name": "קריית עקרון",  "express_enabled": true }, 
    { "city_name": "קריית שלמה",  "express_enabled": false }, 
    { "city_name": "קריית שמונה",  "express_enabled": false }, 
    { "city_name": "קרית חינוך עזתה",  "express_enabled": false }, 
    { "city_name": "קרית תעופה",  "express_enabled": false }, 
    { "city_name": "קרני שומרון",  "express_enabled": false }, 
    { "city_name": "קשת",  "express_enabled": false }, 
    { "city_name": "ראמה",  "express_enabled": false }, 
    { "city_name": "ראס אל-עין",  "express_enabled": false }, 
    { "city_name": "ראס עלי",  "express_enabled": false }, 
    { "city_name": "ראש העין",  "express_enabled": true }, 
    { "city_name": "ראש פינה",  "express_enabled": false }, 
    { "city_name": "ראש צורים",  "express_enabled": false }, 
    { "city_name": "ראשון לציון",  "express_enabled": true }, 
    { "city_name": "רבבה",  "express_enabled": false }, 
    { "city_name": "רבדים",  "express_enabled": false }, 
    { "city_name": "רביבים",  "express_enabled": false }, 
    { "city_name": "רביד",  "express_enabled": false }, 
    { "city_name": "רגבה",  "express_enabled": false }, 
    { "city_name": "רגבים",  "express_enabled": false }, 
    { "city_name": "רהט",  "express_enabled": false }, 
    { "city_name": "רווחה",  "express_enabled": false }, 
    { "city_name": "רוויה",  "express_enabled": false }, 
    { "city_name": "רוח מדבר",  "express_enabled": false }, 
    { "city_name": "רוחמה",  "express_enabled": false }, 
    { "city_name": "רומאנה",  "express_enabled": false }, 
    { "city_name": "רומת הייב",  "express_enabled": false }, 
    { "city_name": "רועי",  "express_enabled": false }, 
    { "city_name": "רותם",  "express_enabled": false }, 
    { "city_name": "רחוב",  "express_enabled": false }, 
    { "city_name": "רחובות",  "express_enabled": true }, 
    { "city_name": "רחלים",  "express_enabled": false }, 
    { "city_name": "ריחאנייה",  "express_enabled": false }, 
    { "city_name": "ריחן",  "express_enabled": false }, 
    { "city_name": "ריינה",  "express_enabled": false }, 
    { "city_name": "רימונים",  "express_enabled": false }, 
    { "city_name": "רינתיה",  "express_enabled": true }, 
    { "city_name": "רכסים",  "express_enabled": false }, 
    { "city_name": "רם-און",  "express_enabled": false }, 
    { "city_name": "רמות",  "express_enabled": false }, 
    { "city_name": "רמות השבים",  "express_enabled": true }, 
    { "city_name": "רמות מאיר",  "express_enabled": false }, 
    { "city_name": "רמות מנשה",  "express_enabled": false }, 
    { "city_name": "רמות נפתלי",  "express_enabled": false }, 
    { "city_name": "רמלה",  "express_enabled": true }, 
    { "city_name": "רמת אפעל",  "express_enabled": true }, 
    { "city_name": "רמת גן",  "express_enabled": true }, 
    { "city_name": "רמת דוד",  "express_enabled": false }, 
    { "city_name": "רמת הכובש",  "express_enabled": false }, 
    { "city_name": "רמת השופט",  "express_enabled": false }, 
    { "city_name": "רמת השרון",  "express_enabled": true }, 
    { "city_name": "רמת טראמפ",  "express_enabled": false }, 
    { "city_name": "רמת יוחנן",  "express_enabled": false }, 
    { "city_name": "רמת ישי",  "express_enabled": true }, 
    { "city_name": "רמת כוכב מ'א 7",  "express_enabled": false }, 
    { "city_name": "רמת כוכב מ'א 8",  "express_enabled": false }, 
    { "city_name": "רמת כוכב מ'א 9",  "express_enabled": false }, 
    { "city_name": "רמת כוכב של'ש",  "express_enabled": false }, 
    { "city_name": "רמת מגשימים",  "express_enabled": false }, 
    { "city_name": "רמת מנשה מ'א 13",  "express_enabled": false }, 
    { "city_name": "רמת מנשה של'ש",  "express_enabled": false }, 
    { "city_name": "רמת צבי",  "express_enabled": false }, 
    { "city_name": "רמת רזיאל",  "express_enabled": false }, 
    { "city_name": "רמת רחל",  "express_enabled": false }, 
    { "city_name": "רנן",  "express_enabled": false }, 
    { "city_name": "רעים",  "express_enabled": false }, 
    { "city_name": "רעננה",  "express_enabled": true }, 
    { "city_name": "רקפת",  "express_enabled": false }, 
    { "city_name": "רשפון",  "express_enabled": true }, 
    { "city_name": "רשפים",  "express_enabled": false }, 
    { "city_name": "רתמים",  "express_enabled": false }, 
    { "city_name": "שאר ישוב",  "express_enabled": false }, 
    { "city_name": "שבי דרום",  "express_enabled": false }, 
    { "city_name": "שבי ציון",  "express_enabled": false }, 
    { "city_name": "שבי שומרון",  "express_enabled": false }, 
    { "city_name": "שבלי - אום אל-גנם",  "express_enabled": false }, 
    { "city_name": "שגב-שלום",  "express_enabled": false }, 
    { "city_name": "שדה אילן",  "express_enabled": false }, 
    { "city_name": "שדה אליהו",  "express_enabled": false }, 
    { "city_name": "שדה אליעזר",  "express_enabled": false }, 
    { "city_name": "שדה בוקר",  "express_enabled": false }, 
    { "city_name": "שדה דוד",  "express_enabled": false }, 
    { "city_name": "שדה ורבורג",  "express_enabled": false }, 
    { "city_name": "שדה יואב",  "express_enabled": false }, 
    { "city_name": "שדה יעקב",  "express_enabled": false }, 
    { "city_name": "שדה יצחק",  "express_enabled": false }, 
    { "city_name": "שדה משה",  "express_enabled": false }, 
    { "city_name": "שדה נחום",  "express_enabled": false }, 
    { "city_name": "שדה נחמיה",  "express_enabled": false }, 
    { "city_name": "שדה ניצן",  "express_enabled": false }, 
    { "city_name": "שדה עוזיהו",  "express_enabled": true }, 
    { "city_name": "שדה צבי",  "express_enabled": false }, 
    { "city_name": "שדות ים",  "express_enabled": true }, 
    { "city_name": "שדות מיכה",  "express_enabled": false }, 
    { "city_name": "שדי אברהם",  "express_enabled": false }, 
    { "city_name": "שדי חמד",  "express_enabled": false }, 
    { "city_name": "שדי תרומות",  "express_enabled": false }, 
    { "city_name": "שדמה",  "express_enabled": false }, 
    { "city_name": "שדמות דבורה",  "express_enabled": false }, 
    { "city_name": "שדמות מחולה",  "express_enabled": false }, 
    { "city_name": "שדרות",  "express_enabled": true }, 
    { "city_name": "שואבה",  "express_enabled": false }, 
    { "city_name": "שובה",  "express_enabled": false }, 
    { "city_name": "שובל",  "express_enabled": false }, 
    { "city_name": "שוהם",  "express_enabled": true }, 
    { "city_name": "שומרה",  "express_enabled": false }, 
    { "city_name": "שומרייה",  "express_enabled": false }, 
    { "city_name": "שוקדה",  "express_enabled": false }, 
    { "city_name": "שורש",  "express_enabled": false }, 
    { "city_name": "שורשים",  "express_enabled": false }, 
    { "city_name": "שושנת העמקים",  "express_enabled": false }, 
    { "city_name": "שזור",  "express_enabled": false }, 
    { "city_name": "שחר",  "express_enabled": false }, 
    { "city_name": "שחרות",  "express_enabled": false }, 
    { "city_name": "שיבולים",  "express_enabled": false }, 
    { "city_name": "שיזף",  "express_enabled": false }, 
    { "city_name": "שיטים",  "express_enabled": false }, 
    { "city_name": "שייח' דנון",  "express_enabled": false }, 
    { "city_name": "שילה",  "express_enabled": false }, 
    { "city_name": "שילת",  "express_enabled": false }, 
    { "city_name": "שכניה",  "express_enabled": false }, 
    { "city_name": "שלווה",  "express_enabled": false }, 
    { "city_name": "שלווה במדבר",  "express_enabled": false }, 
    { "city_name": "שלוחות",  "express_enabled": false }, 
    { "city_name": "שלומי",  "express_enabled": false }, 
    { "city_name": "שלומית",  "express_enabled": false }, 
    { "city_name": "שלומציון",  "express_enabled": false }, 
    { "city_name": "שמיר",  "express_enabled": false }, 
    { "city_name": "שמעה",  "express_enabled": false }, 
    { "city_name": "שמרת",  "express_enabled": false }, 
    { "city_name": "שמשית",  "express_enabled": false }, 
    { "city_name": "שני",  "express_enabled": false }, 
    { "city_name": "שניר",  "express_enabled": false }, 
    { "city_name": "שעב",  "express_enabled": false }, 
    { "city_name": "שעל",  "express_enabled": false }, 
    { "city_name": "שעלבים",  "express_enabled": false }, 
    { "city_name": "שער אפרים",  "express_enabled": false }, 
    { "city_name": "שער הגולן",  "express_enabled": false }, 
    { "city_name": "שער העמקים",  "express_enabled": false }, 
    { "city_name": "שער מנשה",  "express_enabled": false }, 
    { "city_name": "שער שומרון",  "express_enabled": false }, 
    { "city_name": "שפיים",  "express_enabled": true }, 
    { "city_name": "שפיר",  "express_enabled": false }, 
    { "city_name": "שפלת יהודה מ'א 26",  "express_enabled": false }, 
    { "city_name": "שפלת יהודה של'ש",  "express_enabled": false }, 
    { "city_name": "שפר",  "express_enabled": false }, 
    { "city_name": "שפרעם",  "express_enabled": false }, 
    { "city_name": "שקד",  "express_enabled": false }, 
    { "city_name": "שקף",  "express_enabled": false }, 
    { "city_name": "שרונה",  "express_enabled": false }, 
    { "city_name": "שריגים (לי-און)",  "express_enabled": false }, 
    { "city_name": "שריד",  "express_enabled": false }, 
    { "city_name": "שרשרת",  "express_enabled": false }, 
    { "city_name": "שתולה",  "express_enabled": false }, 
    { "city_name": "שתולים",  "express_enabled": true }, 
    { "city_name": "תאשור",  "express_enabled": false }, 
    { "city_name": "תדהר",  "express_enabled": false }, 
    { "city_name": "תובל",  "express_enabled": false }, 
    { "city_name": "תומר",  "express_enabled": false }, 
    { "city_name": "תושייה",  "express_enabled": false }, 
    { "city_name": "תימורים",  "express_enabled": false }, 
    { "city_name": "תירוש",  "express_enabled": false }, 
    { "city_name": "תל אביב -יפו",  "express_enabled": true }, 
    { "city_name": "תל חי (מכללה)",  "express_enabled": false }, 
    { "city_name": "תל יוסף",  "express_enabled": false }, 
    { "city_name": "תל יצחק",  "express_enabled": true }, 
    { "city_name": "תל מונד",  "express_enabled": true }, 
    { "city_name": "תל עדשים",  "express_enabled": false }, 
    { "city_name": "תל קציר",  "express_enabled": false }, 
    { "city_name": "תל שבע",  "express_enabled": false }, 
    { "city_name": "תל תאומים",  "express_enabled": false }, 
    { "city_name": "תלם",  "express_enabled": false }, 
    { "city_name": "תלמי אליהו",  "express_enabled": false }, 
    { "city_name": "תלמי אלעזר",  "express_enabled": false }, 
    { "city_name": "תלמי ביל'ו",  "express_enabled": false }, 
    { "city_name": "תלמי יוסף",  "express_enabled": false }, 
    { "city_name": "תלמי יחיאל",  "express_enabled": false }, 
    { "city_name": "תלמי יפה",  "express_enabled": false }, 
    { "city_name": "תלמים",  "express_enabled": false }, 
    { "city_name": "תמרת",  "express_enabled": false }, 
    { "city_name": "תנובות",  "express_enabled": false }, 
    { "city_name": "תעוז",  "express_enabled": false }, 
    { "city_name": "תפרח",  "express_enabled": false }, 
    { "city_name": "תקומה",  "express_enabled": false }, 
    { "city_name": "תקוע",  "express_enabled": false }, 
    { "city_name": "תראבין א-צאנע (שבט)",  "express_enabled": false }, 
    { "city_name": "תרבין א-צאנע (יישוב)*",  "express_enabled": false }, 
    { "city_name": "תרום",  "express_enabled": false }, 
];*/

window.SHIPPING_CITIES = [
        { "city_name": "אבן יהודה",  "express_enabled": true }, 
    { "city_name": "אביחיל",  "express_enabled": true }, 
    { "city_name": "אודים",  "express_enabled": true }, 
    { "city_name": "אור יהודה",  "express_enabled": true }, 
    { "city_name": "אור עקיבא",  "express_enabled": true }, 
    { "city_name": "אופקים",  "express_enabled": true }, 
    { "city_name": "אזור",  "express_enabled": true }, 
    { "city_name": "אחיסמך",  "express_enabled": true }, 
    { "city_name": "אילת",  "express_enabled": true }, 
    { "city_name": "אלישמע",  "express_enabled": true }, 
    { "city_name": "אמונים",  "express_enabled": true }, 
    { "city_name": "ארסוף",  "express_enabled": true }, 
    { "city_name": "אשדוד",  "express_enabled": true }, 
    { "city_name": "אשקלון",  "express_enabled": true }, 
    { "city_name": "באר גנים",  "express_enabled": true }, 
    { "city_name": "באר יעקב",  "express_enabled": true }, 
    { "city_name": "באר שבע",  "express_enabled": true }, 
    { "city_name": "בארות יצחק",  "express_enabled": true }, 
    { "city_name": "בית אלעזרי",  "express_enabled": true }, 
    { "city_name": "בית דגן",  "express_enabled": true }, 
    { "city_name": "בית חנן",  "express_enabled": true }, 
    { "city_name": "בית חנניה",  "express_enabled": true }, 
    { "city_name": "בית יהושע",  "express_enabled": true }, 
    { "city_name": "בית יצחק",  "express_enabled": true }, 
    { "city_name": "בית יצחק-שער חפר",  "express_enabled": true }, 
    { "city_name": "בית נחמיה",  "express_enabled": true }, 
    { "city_name": "בית עובד",  "express_enabled": true }, 
    { "city_name": "בית עזרא",  "express_enabled": true }, 
    { "city_name": "בית עריף",  "express_enabled": true }, 
    { "city_name": "בית שאן",  "express_enabled": true }, 
    { "city_name": "בן זכאי",  "express_enabled": true }, 
    { "city_name": "בני ברק",  "express_enabled": true }, 
    { "city_name": "בני דרור",  "express_enabled": true }, 
    { "city_name": "בני עטרות",  "express_enabled": true }, 
    { "city_name": "בני עי'ש",  "express_enabled": true }, 
    { "city_name": "בנימינה-גבעת עדה",  "express_enabled": true }, 
    { "city_name": "בצרה",  "express_enabled": true }, 
    { "city_name": "בת ים",  "express_enabled": true }, 
    { "city_name": "גאולים",  "express_enabled": true }, 
    { "city_name": "גאליה",  "express_enabled": true }, 
    { "city_name": "גבעות בר",  "express_enabled": true }, 
    { "city_name": "גבעת ברנר",  "express_enabled": true }, 
    { "city_name": "גבעת השלושה",  "express_enabled": true }, 
    { "city_name": "גבעת ח'ן",  "express_enabled": true }, 
    { "city_name": "גבעת שמואל",  "express_enabled": true }, 
    { "city_name": "גבעתיים",  "express_enabled": true }, 
    { "city_name": "גדרה",  "express_enabled": true }, 
    { "city_name": "גיבתון",  "express_enabled": true }, 
    { "city_name": "גלילות",  "express_enabled": true }, 
    { "city_name": "גליל ים",  "express_enabled": true }, 
    { "city_name": "גן חיים",  "express_enabled": true }, 
    { "city_name": "גן יבנה",  "express_enabled": true }, 
    { "city_name": "גנות הדר",  "express_enabled": true }, 
    { "city_name": "גני יוחנן",  "express_enabled": true }, 
    { "city_name": "גני עם",  "express_enabled": true }, 
    { "city_name": "גני תקווה",  "express_enabled": true }, 
    { "city_name": "געש",  "express_enabled": true }, 
    { "city_name": "גת רימון",  "express_enabled": true }, 
    { "city_name": "הוד השרון",  "express_enabled": true }, 
    { "city_name": "הרצלייה",  "express_enabled": true }, 
    { "city_name": "זכרון יעקב",  "express_enabled": true }, 
    { "city_name": "חדרה",  "express_enabled": true }, 
    { "city_name": "חולון",  "express_enabled": true }, 
    { "city_name": "חיפה",  "express_enabled": true }, 
    { "city_name": "חמ'ד",  "express_enabled": true }, 
    { "city_name": "חצרים",  "express_enabled": true }, 
    { "city_name": "חרות",  "express_enabled": true }, 
    { "city_name": "טבריה",  "express_enabled": true }, 
    { "city_name": "טירת כרמל",  "express_enabled": true }, 
    { "city_name": "יבנה",  "express_enabled": true }, 
    { "city_name": "יגור",  "express_enabled": true }, 
    { "city_name": "יהוד-מונוסון",  "express_enabled": true }, 
    { "city_name": "ינוב",  "express_enabled": true }, 
    { "city_name": "יקום",  "express_enabled": true }, 
    { "city_name": "יקנעם (מושבה)",  "express_enabled": true }, 
    { "city_name": "יקנעם עילית",  "express_enabled": true }, 
    { "city_name": "ירושלים",  "express_enabled": true }, 
    { "city_name": "ירקונה",  "express_enabled": true }, 
    { "city_name": "כפר ביל'ו",  "express_enabled": true }, 
    { "city_name": "כפר הנגיד",  "express_enabled": true }, 
    { "city_name": "כפר טרומן",  "express_enabled": true }, 
    { "city_name": "כפר יונה",  "express_enabled": true }, 
    { "city_name": "כפר מל'ל",  "express_enabled": true }, 
    { "city_name": "כפר מעש",  "express_enabled": true }, 
    { "city_name": "כפר נטר",  "express_enabled": true }, 
    { "city_name": "כפר סבא",  "express_enabled": true }, 
    { "city_name": "כפר סירקין",  "express_enabled": true }, 
    { "city_name": "כפר שמריהו",  "express_enabled": true }, 
    { "city_name": "כרמיאל",  "express_enabled": true }, 
    { "city_name": "להבים",  "express_enabled": true }, 
    { "city_name": "לוד",  "express_enabled": true }, 
    { "city_name": "מגדל העמק",  "express_enabled": true }, 
    { "city_name": "מגשימים",  "express_enabled": true }, 
    { "city_name": "מודיעין-מכבים-רעות",  "express_enabled": true }, 
    { "city_name": "מזור",  "express_enabled": true }, 
    { "city_name": "מזכרת בתיה",  "express_enabled": true }, 
    { "city_name": "מיתר",  "express_enabled": true }, 
    { "city_name": "מעגן מיכאל",  "express_enabled": true }, 
    { "city_name": "מקווה ישראל",  "express_enabled": true }, 
    { "city_name": "משמר השבעה",  "express_enabled": true }, 
    { "city_name": "נהרייה",  "express_enabled": true }, 
    { "city_name": "נווה ימין",  "express_enabled": true }, 
    { "city_name": "נווה ירק",  "express_enabled": true }, 
    { "city_name": "נופך",  "express_enabled": true }, 
    { "city_name": "נורדייה",  "express_enabled": true }, 
    { "city_name": "נחלים",  "express_enabled": true }, 
    { "city_name": "נטעים",  "express_enabled": true }, 
    { "city_name": "ניצנים",  "express_enabled": true }, 
    { "city_name": "ניר צבי",  "express_enabled": true }, 
    { "city_name": "נס ציונה",  "express_enabled": true }, 
    { "city_name": "נשר",  "express_enabled": true }, 
    { "city_name": "נתיבות",  "express_enabled": true }, 
    { "city_name": "נתניה",  "express_enabled": true }, 
    { "city_name": "סביון",  "express_enabled": true }, 
    { "city_name": "עדנים",  "express_enabled": true }, 
    { "city_name": "עומר",  "express_enabled": true }, 
    { "city_name": "עין ורד",  "express_enabled": true }, 
    { "city_name": "עין שריד",  "express_enabled": true }, 
    { "city_name": "עינת",  "express_enabled": true }, 
    { "city_name": "עינות",  "express_enabled": true }, 
    { "city_name": "עכו",  "express_enabled": true }, 
    { "city_name": "עפולה",  "express_enabled": true }, 
    { "city_name": "פרדס חנה-כרכור",  "express_enabled": true }, 
    { "city_name": "פרדסייה",  "express_enabled": true }, 
    { "city_name": "פתח תקווה",  "express_enabled": true }, 
    { "city_name": "צופית",  "express_enabled": true }, 
    { "city_name": "צור משה",  "express_enabled": true }, 
    { "city_name": "קדומים",  "express_enabled": true }, 
    { "city_name": "קדימה-צורן",  "express_enabled": true }, 
    { "city_name": "קדרון",  "express_enabled": true }, 
    { "city_name": "קיסריה",  "express_enabled": true }, 
    { "city_name": "קריית אונו",  "express_enabled": true }, 
    { "city_name": "קריית אתא",  "express_enabled": true }, 
    { "city_name": "קריית ביאליק",  "express_enabled": true }, 
    { "city_name": "קריית גת",  "express_enabled": true }, 
    { "city_name": "קריית טבעון",  "express_enabled": true }, 
    { "city_name": "קריית ים",  "express_enabled": true }, 
    { "city_name": "קריית מוצקין",  "express_enabled": true }, 
    { "city_name": "קריית עקרון",  "express_enabled": true }, 
    { "city_name": "ראש העין",  "express_enabled": true }, 
    { "city_name": "ראשון לציון",  "express_enabled": true }, 
    { "city_name": "רחובות",  "express_enabled": true }, 
    { "city_name": "רינתיה",  "express_enabled": true }, 
    { "city_name": "רמות השבים",  "express_enabled": true }, 
    { "city_name": "רמלה",  "express_enabled": true }, 
    { "city_name": "רמת אפעל",  "express_enabled": true }, 
    { "city_name": "רמת גן",  "express_enabled": true }, 
    { "city_name": "רמת השרון",  "express_enabled": true }, 
    { "city_name": "רמת ישי",  "express_enabled": true }, 
    { "city_name": "רעננה",  "express_enabled": true }, 
    { "city_name": "רשפון",  "express_enabled": true }, 
    { "city_name": "שדה עוזיהו",  "express_enabled": true }, 
    { "city_name": "שדות ים",  "express_enabled": true }, 
    { "city_name": "שדרות",  "express_enabled": true }, 
    { "city_name": "שוהם",  "express_enabled": true }, 
    { "city_name": "שפיים",  "express_enabled": true }, 
    { "city_name": "שתולים",  "express_enabled": true }, 
    { "city_name": "תל אביב -יפו",  "express_enabled": true }, 
    { "city_name": "תל יצחק",  "express_enabled": true }, 
    { "city_name": "תל מונד",  "express_enabled": true }
];